// GENERATED by scripts/build-theme-bundle.js — DO NOT EDIT BY HAND.
// Concatenation order (load-bearing — see build script header for why):
//   srgb-lut.js -> recolor-core.js -> mask-recolor.js -> mask-golden-check.js -> recolor-ui.js
// Build date: 2026-10-23T00:42:13.969Z
// Input SHA-256:
//   engine/srgb-lut.js: 86be2e3c317f9ecf61203f30b7bbf71017fce99773e819607c4545fc90cd149d
//   engine/recolor-core.js: 5cd8fc2a104890c159140d4db905c76d83fae5d0a06fb36cb932effab6c35554
//   engine/mask-recolor.js: 579d14bfcf18583dfb551dad4d978a59105698d95b58e0b103973b5a63ff5335
//   engine/mask-golden-check.js: 60657d3750e38ff0ec22adf61cdb7545f3a3ef77d8928a308256555b5c872e23
//   theme/src/recolor-ui.js: fcc270ee19ce97cd2075020bd477cf29977940889000cc8702aabeb2ae393d62
// GENERATED by scripts/gen-srgb-lut.js — DO NOT EDIT BY HAND.
// 256-entry sRGB byte -> linear decode table, serialized at full double precision.
var QFP_SRGB_LUT = Float64Array.from([
  0,
  0.0003035269835488375,
  0.000607053967097675,
  0.0009105809506465125,
  0.00121410793419535,
  0.0015176349177441874,
  0.001821161901293025,
  0.0021246888848418626,
  0.0024282158683907,
  0.0027317428519395373,
  0.003035269835488375,
  0.003346535763899161,
  0.003676507324047436,
  0.004024717018496307,
  0.004391442037410293,
  0.004776953480693729,
  0.005181516702338386,
  0.005605391624202723,
  0.006048833022857054,
  0.006512090792594475,
  0.006995410187265387,
  0.007499032043226175,
  0.008023192985384994,
  0.008568125618069307,
  0.009134058702220787,
  0.00972121732023785,
  0.010329823029626936,
  0.010960094006488246,
  0.011612245179743885,
  0.012286488356915872,
  0.012983032342173012,
  0.013702083047289686,
  0.014443843596092545,
  0.01520851442291271,
  0.01599629336550963,
  0.016807375752887384,
  0.017641954488384078,
  0.018500220128379697,
  0.019382360956935723,
  0.0202885630566524,
  0.021219010376003555,
  0.022173884793387385,
  0.02315336617811041,
  0.024157632448504756,
  0.02518685962736163,
  0.026241221894849898,
  0.027320891639074894,
  0.028426039504420793,
  0.0295568344378088,
  0.030713443732993635,
  0.03189603307301153,
  0.033104766570885055,
  0.03433980680868217,
  0.03560131487502034,
  0.03688945040110004,
  0.0382043715953465,
  0.03954623527673284,
  0.04091519690685319,
  0.042311410620809675,
  0.043735029256973465,
  0.04518620438567554,
  0.046665086336880095,
  0.04817182422688942,
  0.04970656598412723,
  0.05126945837404324,
  0.052860647023180246,
  0.05448027644244237,
  0.05612849004960009,
  0.05780543019106723,
  0.0595112381629812,
  0.06124605423161761,
  0.06301001765316767,
  0.06480326669290577,
  0.06662593864377289,
  0.06847816984440017,
  0.07036009569659588,
  0.07227185068231748,
  0.07421356838014963,
  0.07618538148130785,
  0.07818742180518633,
  0.08021982031446832,
  0.0822827071298148,
  0.08437621154414882,
  0.08650046203654976,
  0.08865558628577294,
  0.09084171118340768,
  0.09305896284668745,
  0.0953074666309647,
  0.09758734714186246,
  0.09989872824711389,
  0.10224173308810132,
  0.10461648409110419,
  0.10702310297826761,
  0.10946171077829933,
  0.1119324278369056,
  0.11443537382697373,
  0.11697066775851084,
  0.11953842798834562,
  0.12213877222960187,
  0.12477181756095049,
  0.12743768043564743,
  0.1301364766903643,
  0.13286832155381798,
  0.13563332965520566,
  0.13843161503245183,
  0.14126329114027164,
  0.14412847085805777,
  0.14702726649759498,
  0.14995978981060856,
  0.15292615199615017,
  0.1559264637078274,
  0.1589608350608804,
  0.162029375639111,
  0.1651321945016676,
  0.16826940018969075,
  0.1714411007328226,
  0.17464740365558504,
  0.17788841598362912,
  0.18116424424986022,
  0.184474994500441,
  0.18782077230067787,
  0.19120168274079138,
  0.1946178304415758,
  0.19806931955994886,
  0.20155625379439707,
  0.20507873639031693,
  0.20863687014525575,
  0.21223075741405523,
  0.21586050011389926,
  0.2195261997292692,
  0.2232279573168085,
  0.22696587351009836,
  0.23074004852434915,
  0.23455058216100522,
  0.238397573812271,
  0.24228112246555486,
  0.24620132670783548,
  0.25015828472995344,
  0.25415209433082675,
  0.2581828529215958,
  0.26225065752969623,
  0.26635560480286247,
  0.2704977910130658,
  0.27467731206038465,
  0.2788942634768104,
  0.2831487404299921,
  0.2874408377269175,
  0.29177064981753587,
  0.2961382707983211,
  0.3005437944157765,
  0.3049873140698863,
  0.30946892281750854,
  0.31398871337571754,
  0.31854677812509186,
  0.32314320911295075,
  0.3277780980565422,
  0.33245153634617935,
  0.33716361504833037,
  0.3419144249086609,
  0.3467040563550296,
  0.35153259950043936,
  0.3564001441459435,
  0.3613067797835095,
  0.3662525955988395,
  0.3712376804741491,
  0.3762621229909065,
  0.38132601143253014,
  0.386429433787049,
  0.39157247774972326,
  0.39675523072562685,
  0.4019777798321958,
  0.4072402119017367,
  0.41254261348390375,
  0.4178850708481375,
  0.4232676699860717,
  0.4286904966139066,
  0.43415363617474895,
  0.4396571738409188,
  0.44520119451622786,
  0.45078578283822346,
  0.45641102318040466,
  0.4620769996544071,
  0.467783796112159,
  0.47353149614800955,
  0.4793201831008268,
  0.4851499400560704,
  0.4910208498478356,
  0.4969329950608704,
  0.5028864580325687,
  0.5088813208549338,
  0.5149176653765214,
  0.5209955732043543,
  0.5271151257058131,
  0.5332764040105052,
  0.5394794890121072,
  0.5457244613701866,
  0.5520114015120001,
  0.5583403896342679,
  0.5647115057049292,
  0.5711248294648731,
  0.5775804404296506,
  0.5840784178911641,
  0.5906188409193369,
  0.5972017883637634,
  0.6038273388553378,
  0.6104955708078648,
  0.6172065624196511,
  0.6239603916750761,
  0.6307571363461468,
  0.6375968739940326,
  0.6444796819705821,
  0.6514056374198242,
  0.6583748172794485,
  0.665387298282272,
  0.6724431569576875,
  0.6795424696330938,
  0.6866853124353135,
  0.6938717612919899,
  0.7011018919329731,
  0.7083757798916868,
  0.7156935005064807,
  0.7230551289219693,
  0.7304607400903537,
  0.7379104087727308,
  0.7454042095403874,
  0.7529422167760779,
  0.7605245046752924,
  0.768151147247507,
  0.7758222183174236,
  0.7835377915261935,
  0.7912979403326302,
  0.799102738014409,
  0.8069522576692516,
  0.8148465722161012,
  0.8227857543962835,
  0.8307698767746546,
  0.83879901174074,
  0.846873231509858,
  0.8549926081242338,
  0.8631572134541023,
  0.8713671191987972,
  0.8796223968878317,
  0.8879231178819663,
  0.8962693533742664,
  0.9046611743911496,
  0.9130986517934192,
  0.9215818562772946,
  0.9301108583754237,
  0.938685728457888,
  0.9473065367331999,
  0.9559733532492861,
  0.9646862478944651,
  0.9734452903984125,
  0.9822505503331171,
  0.9911020971138298,
  1
]);
if (typeof module !== 'undefined' && module.exports) module.exports = QFP_SRGB_LUT;
else if (typeof window !== 'undefined') window.QFP_SRGB_LUT = QFP_SRGB_LUT;

// QFP recolor engine — SHARED VERBATIM between the theme bundle and the RIP-PC worker.
// DETERMINISM CONTRACT (spec §4.2): the per-pixel path below uses ONLY IEEE-754
// exactly-rounded ops (+ - * / sqrt, comparisons). Math.pow/cbrt/exp/atan2/log/round
// are BANNED in this file. Any output-affecting change must bump ALGO_VERSION.
(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = factory(require('./srgb-lut.js'));
  } else {
    root.RecolorCore = factory(root.QFP_SRGB_LUT);
  }
})(typeof self !== 'undefined' ? self : this, function (SRGB_LUT) {
  'use strict';
  if (!SRGB_LUT || SRGB_LUT.length !== 256 || SRGB_LUT[0] !== 0 || SRGB_LUT[255] !== 1) throw new Error('recolor-core: QFP_SRGB_LUT missing/invalid — load engine/srgb-lut.js first');

  const CORE_VERSION = '1.1.0';
  const ALGO_VERSION = 1;

  const W_EPS = 1e-4;
  const NEUTRAL_C2 = 0.004 * 0.004;
  const GAIN_MAX = 4;
  const GAMUT_ITERS = 14;
  const L_GUARD = 1e-4;

  // Deterministic cube root for x >= 0. Range-reduce by exact *8 / /8 (powers of two
  // are exact in binary floating point; cbrt(x*8^e) = cbrt(x)*2^e), linear initial
  // guess on [0.125, 1), 5 fixed Newton steps y <- (2y + x/y^2)/3. Every operation
  // is exactly rounded, so the result is bit-identical on every conforming JS engine.
  // NaN propagates deterministically (both reduction-loop conditions are false, so it
  // falls through the guess + Newton steps as NaN). The 5-step iteration count is part
  // of the frozen algorithm — changing it requires an ALGO_VERSION bump.
  function cbrtDet(x) {
    if (x <= 0) return 0;
    if (x === Infinity) return Infinity; // Infinity*0.125 === Infinity, so the x>=1 loop would never exit
    let e2 = 1;                       // accumulates 2^e
    while (x < 0.125) { x = x * 8; e2 = e2 * 0.5; }
    while (x >= 1)    { x = x * 0.125; e2 = e2 * 2; }
    let y = 0.4286 + 0.5714 * x;
    for (let i = 0; i < 5; i++) y = (2 * y + x / (y * y)) / 3;
    return y * e2;
  }

  // sRGB (D65) → OKLab, Ottosson constants — verified against
  // https://bottosson.github.io/posts/oklab/ during design research.
  function rgbToOklab(r8, g8, b8, out) {
    const R = SRGB_LUT[r8], G = SRGB_LUT[g8], B = SRGB_LUT[b8];
    return linearToOklab(R, G, B, out);
  }

  function linearToOklab(R, G, B, out) {
    const l = cbrtDet(0.4122214708 * R + 0.5363325363 * G + 0.0514459929 * B);
    const m = cbrtDet(0.2119034982 * R + 0.6806995451 * G + 0.1073969566 * B);
    const s = cbrtDet(0.0883024619 * R + 0.2817188376 * G + 0.6299787005 * B);
    out[0] = 0.2104542553 * l + 0.7936177850 * m - 0.0040720468 * s;
    out[1] = 1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s;
    out[2] = 0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s;
    return out;
  }

  function oklabToLinearRGB(L, a, b, out) {
    const lp = L + 0.3963377774 * a + 0.2158037573 * b;
    const mp = L - 0.1055613458 * a - 0.0638541728 * b;
    const sp = L - 0.0894841775 * a - 1.2914855480 * b;
    const l = lp * lp * lp, m = mp * mp * mp, s = sp * sp * sp;   // cubing is exact ops
    out[0] =  4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s;
    out[1] = -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s;
    out[2] = -0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s;
    return out;
  }

  // Linear → byte: binary search over the monotone LUT. Exact inverse of decode on
  // LUT values; no Math.round anywhere (rounding-rule ambiguity is a determinism hazard).
  // NaN input deterministically returns 0 (all comparisons false → hi collapses to 0) — intentional; callers must not feed NaN.
  function encodeLinear(x) {
    if (x <= 0) return 0;
    if (x >= 1) return 255;
    let lo = 0, hi = 255;
    while (lo < hi) {
      const mid = (lo + hi) >> 1;
      if (x > (SRGB_LUT[mid] + SRGB_LUT[mid + 1]) / 2) lo = mid + 1; else hi = mid;
    }
    return lo;
  }

  // Fractional-byte decode (extraction uses weighted-mean RGB bin representatives).
  function decodeFrac(v) {
    if (v <= 0) return 0;
    if (v >= 255) return 1;
    const f = v - (v | 0), i = v | 0;
    return SRGB_LUT[i] + (SRGB_LUT[i + 1] - SRGB_LUT[i]) * f;
  }

  function preparePalette(pj) {
    if (pj.algo_version !== undefined && pj.algo_version !== ALGO_VERSION) throw new Error('palette: algo_version ' + pj.algo_version + ' != engine ' + ALGO_VERSION);
    if (!Number.isFinite(pj.w_L)) throw new Error('palette: w_L missing/not finite');
    if (!(pj.K >= 1)) throw new Error('palette: K must be >= 1');
    if (!Array.isArray(pj.centroids) || pj.centroids.length < pj.K) throw new Error('palette: centroids shorter than K');
    const K = pj.K;
    const pal = { K, wL: pj.w_L, cL: new Float64Array(K), ca: new Float64Array(K), cb: new Float64Array(K) };
    for (let i = 0; i < K; i++) {
      const c = pj.centroids[i];
      if (!Array.isArray(c) || c.length !== 3 || !c.every(Number.isFinite)) {
        throw new Error('palette: centroid ' + i + ' must be [L,a,b] finite numbers');
      }
      pal.cL[i] = c[0];
      pal.ca[i] = c[1];
      pal.cb[i] = c[2];
    }
    return pal;
  }

  // 3 nearest families under d² = (wL·ΔL)² + Δa² + Δb², ties → lower index
  // (strict < with ascending scan keeps the earlier index on exact ties, which are
  // exact events: both sides compute d² from identical doubles).
  // Raw weights are 1/(d²+ε) scaled by a distance window
  //   f_j = clamp((d3 − d_j) / (d3 − d0), 0, 1)
  // where d3 is the 4th-nearest squared distance: a family's influence fades
  // smoothly to zero exactly where it would fall out of the top-3, so family-
  // boundary crossovers are continuous (no rank-truncation cliff). f_0 is always
  // exactly 1; K<4 or an all-tied window (d3 == d0) disables windowing (all f = 1).
  // Degenerate palettes duplicate an index into the unfilled blend slots but zero
  // that slot's weight, so K=1 puts full weight on the only family and K=2 splits
  // naturally two ways (Task 6's blend of duplicated transfers is unaffected).
  // NaN inputs deterministically yield idx [-1,-1,-1] and NaN weights — callers must not feed NaN.
  function classify(L, a, b, pal, outIdx, outW) {
    const K = pal.K, wL = pal.wL;
    let d0 = Infinity, d1 = Infinity, d2v = Infinity, d3 = Infinity, i0 = -1, i1 = -1, i2 = -1;
    for (let i = 0; i < K; i++) {
      const dL = (L - pal.cL[i]) * wL, da = a - pal.ca[i], db = b - pal.cb[i];
      const d = dL * dL + da * da + db * db;
      if (d < d0)      { d3 = d2v; d2v = d1; i2 = i1; d1 = d0; i1 = i0; d0 = d; i0 = i; }
      else if (d < d1) { d3 = d2v; d2v = d1; i2 = i1; d1 = d;  i1 = i; }
      else if (d < d2v){ d3 = d2v; d2v = d;  i2 = i; }
      else if (d < d3) { d3 = d; }
    }
    if (i1 < 0) { i1 = i0; }                   // K == 1: duplicate index, weight zeroed below
    if (i2 < 0) { i2 = i1; }                   // K == 2
    let f1 = 1, f2 = 1;                        // f0 is always exactly 1
    const span = d3 - d0;
    if (K >= 4 && span > 0) {
      f1 = (d3 - d1) / span;
      f2 = (d3 - d2v) / span;
      if (f1 < 0) f1 = 0; else if (f1 > 1) f1 = 1;
      if (f2 < 0) f2 = 0; else if (f2 > 1) f2 = 1;
    }
    const w0 = 1 / (d0 + W_EPS);
    const w1 = i1 === i0 ? 0 : f1 / (d1 + W_EPS);
    const w2 = (i2 === i1 || i2 === i0) ? 0 : f2 / (d2v + W_EPS);
    const s = w0 + w1 + w2;
    outIdx[0] = i0; outIdx[1] = i1; outIdx[2] = i2;
    if (s === 0) { outW[0] = 1; outW[1] = 0; outW[2] = 0; return; } // safety guard: unreachable for finite input (w0 > 0)
    outW[0] = w0 / s; outW[1] = w1 / s; outW[2] = w2 / s;
  }

  // targets: {familyId: [L,a,b]} — swatch OKLab values FROZEN at approval time.
  function prepareMapping(pal, targets) {
    const K = pal.K;
    const prep = {
      anyMapped: false,
      mapped: new Uint8Array(K),
      TL: new Float64Array(K),
      hiScale: new Float64Array(K), invSL: new Float64Array(K),
      addL: new Uint8Array(K),                 // lightness fallback: additive offset
      addC: new Uint8Array(K),                 // chroma fallback: additive (neutral source)
      kr: new Float64Array(K), ki: new Float64Array(K),
      da: new Float64Array(K), db: new Float64Array(K), // additive offset (addC) OR rotation clamp residual
    };
    for (const key of Object.keys(targets || {})) {
      if (!/^\d+$/.test(key)) throw new Error('mapping: non-integer family key: ' + key);
      if (String(+key) !== key) throw new Error('mapping: non-canonical family key: ' + key);
      const i = +key;
      if (i >= K) throw new Error('mapping: family ' + i + ' out of range (K=' + K + ')');
      const T = targets[key];
      if (!Array.isArray(T) || T.length !== 3 || !T.every(Number.isFinite)) {
        throw new Error('mapping: family ' + i + ' target must be [L,a,b] finite numbers');
      }
      const SL = pal.cL[i], Sa = pal.ca[i], Sb = pal.cb[i];
      prep.mapped[i] = 1; prep.anyMapped = true;
      prep.TL[i] = T[0];
      if (1 - SL < L_GUARD || SL < L_GUARD) {
        prep.addL[i] = 1;                      // guard: near-black/near-white source family
      } else {
        prep.hiScale[i] = (1 - T[0]) / (1 - SL);
        prep.invSL[i] = 1 / SL;
      }
      const c = Sa * Sa + Sb * Sb;
      if (c < NEUTRAL_C2) {
        prep.addC[i] = 1;                      // hue undefined on neutral source: additive
        prep.da[i] = T[1] - Sa; prep.db[i] = T[2] - Sb;
      } else {
        let kr = (T[1] * Sa + T[2] * Sb) / c;
        let ki = (T[2] * Sa - T[1] * Sb) / c;
        const g = Math.sqrt(kr * kr + ki * ki);        // sqrt is exactly rounded: allowed
        if (g > GAIN_MAX) { kr = kr * (GAIN_MAX / g); ki = ki * (GAIN_MAX / g); }
        prep.kr[i] = kr; prep.ki[i] = ki;
        // Clamp residual: guarantees the source centroid lands EXACTLY on the target
        // even when the gain clamp engages (unclamped, the residual is ~a few ulps —
        // harmless and branchless in the per-pixel path).
        prep.da[i] = T[1] - (Sa * kr - Sb * ki);
        prep.db[i] = T[2] - (Sa * ki + Sb * kr);
      }
    }
    return prep;
  }

  // Scratch buffers (module-level: single-threaded JS; worker_thread gets its own module instance)
  const _lab = new Float64Array(3), _lin = new Float64Array(3);
  const _idx = new Int32Array(3), _w = new Float64Array(3);
  const _t = new Float64Array(3);

  function transferFamily(i, prep, pal, L, a, b, out) {
    if (!prep.mapped[i]) { out[0] = L; out[1] = a; out[2] = b; return; }
    const SL = pal.cL[i];
    let tL;
    if (prep.addL[i]) {
      tL = L + (prep.TL[i] - SL);
      if (tL < 0) tL = 0; else if (tL > 1) tL = 1;
    } else if (L >= SL) {
      tL = prep.TL[i] + (L - SL) * prep.hiScale[i];
    } else {
      tL = prep.TL[i] * (L * prep.invSL[i]);
    }
    let ta, tb;
    if (prep.addC[i]) { ta = a + prep.da[i]; tb = b + prep.db[i]; }
    else {
      ta = a * prep.kr[i] - b * prep.ki[i] + prep.da[i];  // + clamp residual
      tb = a * prep.ki[i] + b * prep.kr[i] + prep.db[i];
    }
    out[0] = tL; out[1] = ta; out[2] = tb;
  }

  // Post-classification tail of mapColorPacked: blend the (up to) 3 family transfers,
  // clamp L, gamut-clip, encode. Extracted verbatim (loop unrolled in the same
  // accumulation order — bit-identical) so createClassifiedSession can reuse it.
  function blendClassified(L, a, b, i0, i1, i2, w0, w1, w2, pal, prep) {
    let oL = 0, oa = 0, ob = 0;
    transferFamily(i0, prep, pal, L, a, b, _t);
    oL += w0 * _t[0]; oa += w0 * _t[1]; ob += w0 * _t[2];
    transferFamily(i1, prep, pal, L, a, b, _t);
    oL += w1 * _t[0]; oa += w1 * _t[1]; ob += w1 * _t[2];
    transferFamily(i2, prep, pal, L, a, b, _t);
    oL += w2 * _t[0]; oa += w2 * _t[1]; ob += w2 * _t[2];
    if (oL < 0) oL = 0; else if (oL > 1) oL = 1;
    oklabToLinearRGB(oL, oa, ob, _lin);
    if (_lin[0] < -1e-6 || _lin[0] > 1 + 1e-6 ||
        _lin[1] < -1e-6 || _lin[1] > 1 + 1e-6 ||
        _lin[2] < -1e-6 || _lin[2] > 1 + 1e-6) {
      // Lightness-preserving chroma reduction: binary-search largest in-gamut t
      let lo = 0, hi = 1;
      for (let it = 0; it < GAMUT_ITERS; it++) {
        const mid = (lo + hi) * 0.5;
        oklabToLinearRGB(oL, mid * oa, mid * ob, _lin);
        if (_lin[0] >= -1e-6 && _lin[0] <= 1 + 1e-6 &&
            _lin[1] >= -1e-6 && _lin[1] <= 1 + 1e-6 &&
            _lin[2] >= -1e-6 && _lin[2] <= 1 + 1e-6) lo = mid; else hi = mid;
      }
      oklabToLinearRGB(oL, lo * oa, lo * ob, _lin);
    }
    return (encodeLinear(_lin[0]) << 16) | (encodeLinear(_lin[1]) << 8) | encodeLinear(_lin[2]);
  }

  function mapColorPacked(p, pal, prep) {
    const r = (p >> 16) & 255, g = (p >> 8) & 255, b8 = p & 255;
    rgbToOklab(r, g, b8, _lab);
    classify(_lab[0], _lab[1], _lab[2], pal, _idx, _w);
    if (!prep.anyMapped ||
        (!prep.mapped[_idx[0]] && !prep.mapped[_idx[1]] && !prep.mapped[_idx[2]])) {
      return p & 0xffffff;                      // early-out: nothing relevant mapped (uniform 24-bit contract)
    }
    return blendClassified(_lab[0], _lab[1], _lab[2], _idx[0], _idx[1], _idx[2],
                           _w[0], _w[1], _w[2], pal, prep);
  }

  // Display-only OKLab → hex helper (extraction UI, swatch libraries). Gamut-clips
  // identically to mapColorPacked's chroma-reduction path. Not on the per-pixel hot
  // path, so this is fine to keep separate rather than factored into mapColorPacked.
  function oklabToHex(L, a, b) {
    oklabToLinearRGB(L, a, b, _lin);
    if (_lin[0] < -1e-6 || _lin[0] > 1 + 1e-6 ||
        _lin[1] < -1e-6 || _lin[1] > 1 + 1e-6 ||
        _lin[2] < -1e-6 || _lin[2] > 1 + 1e-6) {
      let lo = 0, hi = 1;
      for (let it = 0; it < GAMUT_ITERS; it++) {
        const mid = (lo + hi) * 0.5;
        oklabToLinearRGB(L, mid * a, mid * b, _lin);
        if (_lin[0] >= -1e-6 && _lin[0] <= 1 + 1e-6 &&
            _lin[1] >= -1e-6 && _lin[1] <= 1 + 1e-6 &&
            _lin[2] >= -1e-6 && _lin[2] <= 1 + 1e-6) lo = mid; else hi = mid;
      }
      oklabToLinearRGB(L, lo * a, lo * b, _lin);
    }
    const h = v => v.toString(16).padStart(2, '0');
    return '#' + h(encodeLinear(_lin[0])) + h(encodeLinear(_lin[1])) + h(encodeLinear(_lin[2]));
  }

  // Browser fast path (spec §4.3): classification is mapping-independent, so a modal
  // computes it ONCE at open; each swatch tap re-runs only the transfer via the SAME
  // blend/gamut code mapColorPacked uses. Output-identical to mapColorPacked by construction.
  function createClassifiedSession(paletteJson) {
    const pal = preparePalette(paletteJson);
    const cls = new Map();     // packed rgb -> Float64Array [L,a,b,i0,i1,i2,w0,w1,w2]
    function classifyColor(p) {
      let e = cls.get(p);
      if (e === undefined) {
        rgbToOklab((p >> 16) & 255, (p >> 8) & 255, p & 255, _lab);
        classify(_lab[0], _lab[1], _lab[2], pal, _idx, _w);
        e = Float64Array.from([_lab[0], _lab[1], _lab[2], _idx[0], _idx[1], _idx[2], _w[0], _w[1], _w[2]]);
        cls.set(p, e);
      }
      return e;
    }
    function mapWith(prep, r, g, b) {
      const p = ((r << 16) | (g << 8) | b) & 0xffffff;
      const e = classifyColor(p);
      const i0 = e[3] | 0, i1 = e[4] | 0, i2 = e[5] | 0;
      if (!prep.anyMapped || (!prep.mapped[i0] && !prep.mapped[i1] && !prep.mapped[i2])) return p;
      return blendClassified(e[0], e[1], e[2], i0, i1, i2, e[6], e[7], e[8], pal, prep);
    }
    return { pal, prepare: (targets) => prepareMapping(pal, targets || {}), mapWith };
  }

  // cache 'map'  → JS Map (browser preview: ~10^4-10^5 unique colors)
  // cache 'lut'  → Int32Array(1<<24), 67MB, -1 sentinel (RIP worker: fastest, measured
  //                0.4-1.3s per 142.5MP vs 20s uncached). Cache choice cannot affect
  //                output — misses recompute the same pure function.
  function createMapper(paletteJson, targets, opts) {
    const pal = preparePalette(paletteJson);
    const prep = prepareMapping(pal, targets || {});
    const kind = (opts && opts.cache) || 'map';
    if (kind !== 'map' && kind !== 'lut') throw new Error('createMapper: unknown cache kind: ' + kind);
    let lut = null, memo = null;
    if (kind === 'lut') { lut = new Int32Array(1 << 24); lut.fill(-1); }
    else memo = new Map();

    // r,g,b must be integers 0-255; out-of-range inputs are undefined behavior.
    function map(r, g, b) {
      const p = (r << 16) | (g << 8) | b;
      if (lut) {
        let q = lut[p];
        if (q < 0) { q = mapColorPacked(p, pal, prep); lut[p] = q; }
        return q;
      }
      let q = memo.get(p);
      if (q === undefined) { q = mapColorPacked(p, pal, prep); memo.set(p, q); }
      return q;
    }

    function remapRGB(buf) {
      if (buf.length % 3) throw new Error('remapRGB: buffer length not a multiple of 3');
      for (let i = 0; i < buf.length; i += 3) {
        const q = map(buf[i], buf[i + 1], buf[i + 2]);
        buf[i] = (q >> 16) & 255; buf[i + 1] = (q >> 8) & 255; buf[i + 2] = q & 255;
      }
    }

    function remapRGBA(buf) {
      if (buf.length % 4) throw new Error('remapRGBA: buffer length not a multiple of 4');
      for (let i = 0; i < buf.length; i += 4) {
        const q = map(buf[i], buf[i + 1], buf[i + 2]);
        buf[i] = (q >> 16) & 255; buf[i + 1] = (q >> 8) & 255; buf[i + 2] = q & 255;
      }
    }

    // pal/prep are exposed for tests/debug; treat as frozen — mutating them desyncs cached entries.
    return { map, remapRGB, remapRGBA, pal, prep };
  }

  return {
    CORE_VERSION, ALGO_VERSION,
    W_EPS, NEUTRAL_C2, GAIN_MAX, GAMUT_ITERS, L_GUARD,
    cbrtDet, decodeFrac, rgbToOklab, linearToOklab, oklabToLinearRGB, encodeLinear,
    oklabToHex,
    preparePalette, classify,
    prepareMapping, mapColorPacked,
    createMapper, createClassifiedSession,
  };
});

// QFP mask recolor engine (Paint Brush regions) — SHARED VERBATIM between the theme
// bundle and the RIP-PC worker, exactly like recolor-core.js.
// DETERMINISM CONTRACT (spec 2026-07-18 §4): the per-pixel path uses ONLY IEEE-754
// exactly-rounded ops (+ - * / sqrt, comparisons, Math.floor — floor is exact).
// Math.pow/cbrt/exp/atan2/log/round are BANNED in this file. Any output-affecting
// change must bump MASK_ALGO_VERSION.
//
// All color math is DELEGATED to recolor-core: a mask region is treated as a K=1
// palette whose sole centroid is the region's frozen `src` OKLab, mapped to the
// frozen `target`. classify() on a K=1 palette puts weight EXACTLY 1 on family 0
// (see "classify: K=1 palette gives the only family full weight" in test/core.test.js),
// so mapColorPacked runs precisely the family transfer (headroom lightness transfer
// + chroma gain-clamp + gamut clip + LUT encode) with `src` as the reference
// centroid — no constants or transfer logic are duplicated here.
(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = factory(require('./recolor-core.js'));
  } else {
    root.QFPMaskRecolor = factory(root.RecolorCore);
  }
})(typeof self !== 'undefined' ? self : this, function (RC) {
  'use strict';
  if (!RC || typeof RC.mapColorPacked !== 'function') throw new Error('mask-recolor: RecolorCore missing — load engine/recolor-core.js first');

  const MASK_CORE_VERSION = '1.0.0';
  const MASK_ALGO_VERSION = 1;

  // MASK_ALGO_VERSION 1 is defined AGAINST core ALGO_VERSION 1: every output flows
  // through core's frozen transfer. A deliberate core bump changes mask output too,
  // so it must arrive together with a mask module review + MASK_ALGO_VERSION bump.
  if (RC.ALGO_VERSION !== 1) throw new Error('mask-recolor: recolor-core ALGO_VERSION ' + RC.ALGO_VERSION + ' != pinned 1 — review mask math and bump MASK_ALGO_VERSION');

  // w_L for the synthetic K=1 palette. Provably output-inert: with K=1, classify()
  // assigns family 0 weight exactly 1 whatever the distance, and the transfer itself
  // never reads w_L. Kept at the repo-conventional 0.6 purely so debug dumps of the
  // prepared palette look familiar.
  const MASK_WL = 0.6;

  function checkLab(v, name) {
    if (!Array.isArray(v) && !(ArrayBuffer.isView(v) && !(v instanceof DataView))) {
      throw new Error('mask: ' + name + ' must be [L,a,b] finite numbers');
    }
    if (v.length !== 3 || !Number.isFinite(v[0]) || !Number.isFinite(v[1]) || !Number.isFinite(v[2])) {
      throw new Error('mask: ' + name + ' must be [L,a,b] finite numbers');
    }
  }

  // Build the K=1 pal/prep pair for a (src, target) transform. Pure function of the
  // 6 doubles; prepared structs are frozen by convention (see recolor-core).
  function prepareTransform(src, target) {
    checkLab(src, 'src');
    checkLab(target, 'target');
    const pal = RC.preparePalette({ K: 1, w_L: MASK_WL, centroids: [[src[0], src[1], src[2]]] });
    const prep = RC.prepareMapping(pal, { 0: [target[0], target[1], target[2]] });
    return { pal, prep };
  }

  // One-entry transform cache for maskRecolorPixel: repeated calls with the same
  // src/target values (the common per-region pattern) skip re-preparation. A cache
  // hit cannot affect output — preparation is a pure function of the 6 doubles.
  let _ckey0 = NaN, _ckey1 = NaN, _ckey2 = NaN, _ckey3 = NaN, _ckey4 = NaN, _ckey5 = NaN;
  let _cached = null;

  // r,g,b: integer bytes 0-255 (out-of-range is undefined behavior, as in
  // recolor-core's map). src/target: [L,a,b] finite numbers. out: array-like of
  // length >= 3, receives the recolored bytes; returned for convenience.
  function maskRecolorPixel(r, g, b, src, target, out) {
    checkLab(src, 'src');                       // before the cache probe (it indexes src/target)
    checkLab(target, 'target');
    let t = _cached;
    if (t === null ||
        src[0] !== _ckey0 || src[1] !== _ckey1 || src[2] !== _ckey2 ||
        target[0] !== _ckey3 || target[1] !== _ckey4 || target[2] !== _ckey5) {
      t = prepareTransform(src, target);
      _ckey0 = src[0]; _ckey1 = src[1]; _ckey2 = src[2];
      _ckey3 = target[0]; _ckey4 = target[1]; _ckey5 = target[2];
      _cached = t;
    }
    const q = RC.mapColorPacked(((r << 16) | (g << 8) | b) & 0xffffff, t.pal, t.prep);
    out[0] = (q >> 16) & 255; out[1] = (q >> 8) & 255; out[2] = q & 255;
    return out;
  }

  // FROZEN bilinear sampler (spec §4) for applying a preview-resolution mask at
  // master resolution (worker side; the browser paints at preview res 1:1 and never
  // resamples). Source coords sx = (x + 0.5) * mw / W - 0.5 (same for y),
  // clamp-to-edge on the 4 neighbor indices, bilinear blend, round half up to 0..255.
  // At identical dims the sampler is the exact identity: (x+0.5)*mw is an exact
  // product (small-int magnitudes), /W recovers x+0.5 exactly, so fx = fy = 0 and
  // the texel value passes through untouched (frozen by a test).
  function sampleMaskBilinear(alpha, mw, mh, x, y, W, H) {
    const sx = (x + 0.5) * mw / W - 0.5;
    const sy = (y + 0.5) * mh / H - 0.5;
    let x0 = Math.floor(sx), y0 = Math.floor(sy);
    const fx = sx - x0, fy = sy - y0;           // fractions BEFORE clamping (clamp-to-edge)
    let x1 = x0 + 1, y1 = y0 + 1;
    if (x0 < 0) x0 = 0; else if (x0 > mw - 1) x0 = mw - 1;
    if (x1 < 0) x1 = 0; else if (x1 > mw - 1) x1 = mw - 1;
    if (y0 < 0) y0 = 0; else if (y0 > mh - 1) y0 = mh - 1;
    if (y1 < 0) y1 = 0; else if (y1 > mh - 1) y1 = mh - 1;
    const r0 = y0 * mw, r1 = y1 * mw;
    const a00 = alpha[r0 + x0], a10 = alpha[r0 + x1];
    const a01 = alpha[r1 + x0], a11 = alpha[r1 + x1];
    const top = a00 + (a10 - a00) * fx;
    const bot = a01 + (a11 - a01) * fx;
    let v = Math.floor(top + (bot - top) * fy + 0.5);   // round half up (floor is exact)
    if (v < 0) v = 0; else if (v > 255) v = 255;
    return v;
  }

  // Buffers carry 3 (RGB) or 4 (RGBA/ImageData) bytes per pixel — inferred from
  // length, mirroring recolor-core's remapRGB/remapRGBA pair. RGBA alpha bytes are
  // never read or written; the pixel color math is channel-layout independent.
  function channelsOf(buf, w, h, who) {
    const n = w * h;
    if (!(n > 0)) throw new Error(who + ': bad dims ' + w + 'x' + h);
    if (buf.length === n * 3) return 3;
    if (buf.length === n * 4) return 4;
    throw new Error(who + ': buffer length ' + buf.length + ' is not ' + w + 'x' + h + ' RGB or RGBA');
  }

  // Full-buffer pass implementing spec §2 step 2 for ONE committed region:
  // per pixel where mask alpha > 0, compute the mask-recolored value and lerp
  //   out = orig + (recolored - orig) * alpha/255   per channel, round half up, clamp.
  // Callers apply regions in commit order (region N sees the output of region N-1).
  // region: { alpha: byte array (region.w * region.h), w, h, src: [L,a,b],
  //           target: [L,a,b] } — extra fields (swatchId, ...) are ignored.
  // When region dims differ from buf dims (worker: preview-res mask on the master
  // image) the mask is read through sampleMaskBilinear; at equal dims it is read
  // 1:1 (bit-identical to the sampler by the identity property above).
  // Recolor results are memoized per packed input color — a pure-function cache,
  // output-unaffected (same rationale as recolor-core's createMapper caches).
  function applyMaskRGB(buf, w, h, region) {
    const ch = channelsOf(buf, w, h, 'applyMaskRGB');
    if (!region || !region.alpha) throw new Error('applyMaskRGB: region.alpha missing');
    const mw = region.w, mh = region.h;
    if (!(mw > 0) || !(mh > 0) || region.alpha.length !== mw * mh) {
      throw new Error('applyMaskRGB: region.alpha length ' + region.alpha.length + ' != ' + mw + 'x' + mh);
    }
    const t = prepareTransform(region.src, region.target);
    const alpha = region.alpha;
    const direct = (mw === w && mh === h);
    const memo = new Map();                     // packed orig -> packed recolored
    let i = 0;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++, i += ch) {
        const a = direct ? alpha[y * w + x] : sampleMaskBilinear(alpha, mw, mh, x, y, w, h);
        if (a === 0) continue;
        const r = buf[i], g = buf[i + 1], b = buf[i + 2];
        const p = (r << 16) | (g << 8) | b;
        let q = memo.get(p);
        if (q === undefined) { q = RC.mapColorPacked(p, t.pal, t.prep); memo.set(p, q); }
        const f = a / 255;
        // Convex blend of two in-range ints stays in [0,255]; clamp kept as a guard.
        let vr = Math.floor(r + (((q >> 16) & 255) - r) * f + 0.5);
        let vg = Math.floor(g + (((q >> 8) & 255) - g) * f + 0.5);
        let vb = Math.floor(b + ((q & 255) - b) * f + 0.5);
        if (vr < 0) vr = 0; else if (vr > 255) vr = 255;
        if (vg < 0) vg = 0; else if (vg > 255) vg = 255;
        if (vb < 0) vb = 0; else if (vb > 255) vb = 255;
        buf[i] = vr; buf[i + 1] = vg; buf[i + 2] = vb;
      }
    }
  }

  // Alpha-weighted mean OKLab of the pixels under a mask (browser commit step:
  // freezes a region's `src`; the worker never calls this — src arrives frozen in
  // the mapping JSON). alpha must be at buf dims (the browser paints at preview
  // res 1:1). Accumulates in raster order — fixed-order IEEE sums, deterministic.
  // Returns [L, a, b] plain array, or null when no pixel has alpha > 0 (caller
  // must not commit an empty mask).
  function maskCentroid(buf, w, h, alpha) {
    const ch = channelsOf(buf, w, h, 'maskCentroid');
    if (!alpha || alpha.length !== w * h) {
      throw new Error('maskCentroid: alpha length ' + (alpha && alpha.length) + ' != ' + w + 'x' + h);
    }
    const lab = new Float64Array(3);
    let sw = 0, sL = 0, sa = 0, sb = 0;
    for (let j = 0, i = 0; j < alpha.length; j++, i += ch) {
      const a = alpha[j];
      if (a === 0) continue;
      RC.rgbToOklab(buf[i], buf[i + 1], buf[i + 2], lab);
      sw = sw + a;
      sL = sL + a * lab[0];
      sa = sa + a * lab[1];
      sb = sb + a * lab[2];
    }
    if (sw === 0) return null;
    return [sL / sw, sa / sw, sb / sw];
  }

  return {
    MASK_CORE_VERSION, MASK_ALGO_VERSION,
    maskRecolorPixel, applyMaskRGB, sampleMaskBilinear, maskCentroid,
  };
});

// engine/mask-golden-check.js — the ONE mask-fixture verification loop, shared by
// every consumer exactly like engine/golden-check.js: `npm test`
// (test/mask-golden.test.js), the browser harness self-test, and the worker startup
// selftest (alongside the existing 40k golden check — refuse to render on drift).
// Dependency-free: the mask engine (MR) is passed in.
(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = factory();
  } else {
    root.QFPMaskGoldenCheck = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var MAX_FAILURES = 20;

  // Returns {ok, checked, failures: [{stage, index, input, got, want}]}.
  //   index >= 0  → pixel mismatch at that raster index (input = original packed px,
  //                 got/want = packed output pixels)
  //   index == -1 → MASK_ALGO_VERSION mismatch (stage '(mask_algo_version)') —
  //                 short-circuits: the fixture belongs to a different frozen
  //                 algorithm, byte-comparing is meaningless
  //   index == -2 → frozen-src centroid drift (input = L/a/b component 0-2,
  //                 got/want = doubles) — maskCentroid no longer reproduces the
  //                 fixture's committed src bit-for-bit
  // Failure collection bails after MAX_FAILURES entries: enough to diagnose,
  // without flooding logs when an engine build is wholesale broken.
  function checkMaskGolden(MR, fixture) {
    if (fixture.mask_algo_version !== MR.MASK_ALGO_VERSION) {
      return {
        ok: false, checked: 0,
        failures: [{ stage: '(mask_algo_version)', index: -1, input: -1,
                     got: MR.MASK_ALGO_VERSION, want: fixture.mask_algo_version }],
      };
    }
    var failures = [];
    var checked = 0;
    var W = fixture.w, H = fixture.h, n = W * H;
    // Unpack the base image into an RGB working buffer (stages mutate it in commit order).
    var buf = new Uint8ClampedArray(n * 3);
    for (var i = 0; i < n; i++) {
      var p = fixture.image[i];
      buf[i * 3] = (p >> 16) & 255; buf[i * 3 + 1] = (p >> 8) & 255; buf[i * 3 + 2] = p & 255;
    }
    outer:
    for (var k = 0; k < fixture.masks.length; k++) {
      var m = fixture.masks[k];
      if (m.src_from_centroid) {
        // Re-derive the frozen src the way the browser commit did (centroid of the
        // CURRENT buffer under the mask) and demand bit-exact doubles.
        var c = MR.maskCentroid(buf, W, H, m.alpha);
        for (var j = 0; j < 3; j++) {
          checked++;
          if (c === null || c[j] !== m.src[j]) {
            failures.push({ stage: k, index: -2, input: j,
                            got: c === null ? null : c[j], want: m.src[j] });
            if (failures.length >= MAX_FAILURES) break outer;
          }
        }
      }
      MR.applyMaskRGB(buf, W, H, m);
      var want = fixture.expected[k];
      for (var q = 0; q < n; q++) {
        var got = (buf[q * 3] << 16) | (buf[q * 3 + 1] << 8) | buf[q * 3 + 2];
        checked++;
        if (got !== want[q]) {
          failures.push({ stage: k, index: q, input: fixture.image[q], got: got, want: want[q] });
          if (failures.length >= MAX_FAILURES) break outer;
        }
      }
    }
    return { ok: failures.length === 0, checked: checked, failures: failures };
  }

  return { checkMaskGolden: checkMaskGolden };
});

// theme/src/recolor-ui.js — SOURCE OF TRUTH for the customer-facing "Customize
// Colors" modal's logic. UMD-lite like engine/recolor-core.js: in Node this
// requires RecolorCore directly (module.exports branch, used by
// theme/test/ui-logic.test.js); in the browser it reads window.RecolorCore,
// which scripts/build-theme-bundle.js guarantees is already defined because
// the bundle concatenates srgb-lut.js + recolor-core.js ahead of this file.
//
// PURE functions (state/price/summary/payload builders — the bulk of Task 1,
// TDD'd in theme/test/ui-logic.test.js) are kept strictly separate from the
// DOM controller, which lives entirely under the `_dom` namespace and is a
// stub until Task 2.
(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = factory(require('../../engine/recolor-core.js'));
  } else {
    root.QfpRecolorUI = factory(root.RecolorCore);
  }
})(typeof self !== 'undefined' ? self : this, function (RecolorCore) {
  'use strict';
  if (!RecolorCore) throw new Error('recolor-ui: RecolorCore missing — load engine/srgb-lut.js + engine/recolor-core.js first');

  // ---------------------------------------------------------------------
  // pickAssetSize — spec §6: 1200px preview asset for viewport <=768px,
  // else the 1600px asset. Boundary is inclusive on the small side.
  // ---------------------------------------------------------------------
  function pickAssetSize(viewportW) {
    return viewportW <= 768 ? 1200 : 1600;
  }

  // ---------------------------------------------------------------------
  // priceLine — "+25% — $X.XX" money line for the price footer.
  // MUST agree bit-for-bit with the Cart Transform function's math
  // (shopify-app/qfp-recolor-app/extensions/recolor-upcharge/src/cart_transform_run.js):
  //   base = parseFloat(amountPerQuantity.amount)   // decimal dollars string
  //   price = (base * RECOLOR_UPCHARGE_MULTIPLIER).toFixed(2)
  // The theme only ever has the price in integer cents (Liquid `product.price`),
  // so this is the ONE canonical formula: dollars = cents/100 (same double a
  // 2-decimal Shopify money string parses to), then the identical multiply+toFixed.
  // See theme/test/ui-logic.test.js for the cross-check against the transform.
  // ---------------------------------------------------------------------
  var UPCHARGE_MULTIPLIER = 1.25;

  // Upcharge percent derived from the multiplier (never hardcode "25"): if the
  // multiplier ever changes, both the wording and the math move together.
  function upchargePct() { return Math.round((UPCHARGE_MULTIPLIER - 1) * 100); }

  // THE canonical post-upcharge total (string, 2dp) — the single source both
  // priceLine and priceFooter share, so the number shown can never drift from
  // the number charged (Cart Transform charges (base*1.25).toFixed(2)).
  function upchargeTotal(basePriceCents) {
    if (typeof basePriceCents !== 'number' || !Number.isFinite(basePriceCents) || basePriceCents < 0) {
      throw new Error('upchargeTotal: basePriceCents must be a non-negative finite number (integer cents)');
    }
    var dollars = basePriceCents / 100;
    return (dollars * UPCHARGE_MULTIPLIER).toFixed(2);
  }

  function priceLine(basePriceCents) {
    return '+' + upchargePct() + '% — $' + upchargeTotal(basePriceCents);
  }

  // priceFooter — the customer-facing footer/approval wording (Aaron
  // 2026-07-14): full sentence, percent from the constant, total identical to
  // priceLine's (displayed==charged parity).
  function priceFooter(basePriceCents) {
    return 'There is an upcharge of ' + upchargePct() +
      '% for changing colors in each panel - Total: $' + upchargeTotal(basePriceCents) + ' per panel';
  }

  // ---------------------------------------------------------------------
  // summary — human-readable "Custom Colors" cart property text.
  // Frozen contract example: `Custom Colors` = "3 colors changed".
  // Lists up to 3 target swatch names (by ascending numeric family id, so
  // the text is deterministic regardless of object key insertion order),
  // then "+N more" for the remainder.
  // ---------------------------------------------------------------------
  function swatchName(swatches, swatchId) {
    for (var i = 0; i < swatches.length; i++) {
      if (swatches[i].swatch_id === swatchId) return swatches[i].name;
    }
    return swatchId; // fallback: never throw on an unknown id, just show the raw id
  }

  function summary(mapping, swatches) {
    var familyIds = Object.keys(mapping || {}).map(Number).sort(function (a, b) { return a - b; });
    var n = familyIds.length;
    if (n === 0) return 'No colors changed';

    var names = familyIds.slice(0, 3).map(function (fid) {
      return swatchName(swatches || [], mapping[String(fid)]);
    });
    var extra = n - names.length;
    var head = n + ' color' + (n === 1 ? '' : 's') + ' changed — ' + names.join(', ');
    return extra > 0 ? head + ' — +' + extra + ' more' : head;
  }

  // ---------------------------------------------------------------------
  // deltaEWarnings — OKLab Euclidean distance < 0.04 across the EFFECTIVE
  // post-mapping family colors (spec §6, warn-only). For each family: if
  // mapped, the effective color is the target swatch's OKLab (converted
  // from its hex via RecolorCore); if unmapped, it's the family's own
  // centroid (already stored as [L,a,b] — no conversion needed). Every
  // pair of families whose effective colors are nearly indistinguishable
  // is reported so the picker can warn the customer before they approve.
  // ---------------------------------------------------------------------
  var DELTA_E_WARN_THRESHOLD = 0.04;

  function hexToRgbTriple(hex) {
    var h = String(hex).replace('#', '');
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  function effectiveFamilyLab(pal, mapping, swatches, i) {
    var swatchId = mapping[String(i)];
    if (swatchId === undefined) {
      return [pal.cL[i], pal.ca[i], pal.cb[i]];
    }
    var hex = null;
    for (var s = 0; s < swatches.length; s++) {
      if (swatches[s].swatch_id === swatchId) { hex = swatches[s].hex; break; }
    }
    if (hex === null) return [pal.cL[i], pal.ca[i], pal.cb[i]]; // unknown swatch id: fall back rather than throw
    var rgb = hexToRgbTriple(hex);
    var out = [0, 0, 0];
    RecolorCore.rgbToOklab(rgb[0], rgb[1], rgb[2], out);
    return out;
  }

  function deltaEWarnings(palette, mapping, swatches) {
    mapping = mapping || {};
    swatches = swatches || [];
    var pal = RecolorCore.preparePalette(palette);
    var effective = [];
    for (var i = 0; i < pal.K; i++) effective.push(effectiveFamilyLab(pal, mapping, swatches, i));

    var warnings = [];
    for (var a = 0; a < pal.K; a++) {
      for (var b = a + 1; b < pal.K; b++) {
        var dL = effective[a][0] - effective[b][0];
        var da = effective[a][1] - effective[b][1];
        var db = effective[a][2] - effective[b][2];
        var d = Math.sqrt(dL * dL + da * da + db * db);
        if (d < DELTA_E_WARN_THRESHOLD) warnings.push({ familyA: a, familyB: b, distance: d });
      }
    }
    return warnings;
  }

  // ---------------------------------------------------------------------
  // buildApprovePayloadMeta — the non-binary fields of the approve POST
  // (spec "Frozen contracts"; preview_jpeg is a Blob attached by the DOM
  // controller, not built here). product_id is canonicalized to a decimal
  // string via BigInt (exact for arbitrarily large ids, unlike Number()) —
  // '0123' -> '123'.
  // ---------------------------------------------------------------------
  function canonicalProductId(productId) {
    return String(BigInt(productId));
  }

  function buildApprovePayloadMeta(productId, paletteHash, coreVersion, mapping) {
    return {
      product_id: canonicalProductId(productId),
      palette_hash: paletteHash,
      core_version: coreVersion,
      mapping: JSON.stringify(mapping || {}),
    };
  }

  // ---------------------------------------------------------------------
  // buildCartProperties — the EXACT 4 cart-line properties written on add
  // (frozen contract). NEVER `_recolor_base_price` — that key is written
  // ONLY by the Cart Transform function server-side; the theme must never
  // fake/duplicate it.
  // ---------------------------------------------------------------------
  function buildCartProperties(summaryText, token, mapping, previewUrl) {
    return {
      'Custom Colors': summaryText,
      '_recolor_token': token,
      '_recolor_mapping': JSON.stringify(mapping || {}),
      '_preview_url': previewUrl,
    };
  }

  // ---------------------------------------------------------------------
  // serializeState/parseState — localStorage persistence, shape
  // {paletteHash, mapping, v:1}. parseState NEVER throws: malformed JSON,
  // a version mismatch, or missing fields all return null so the caller
  // can fall back to a fresh session rather than crash on a stale/corrupt
  // localStorage entry.
  // ---------------------------------------------------------------------
  var STATE_VERSION = 1;

  function serializeState(paletteHash, mapping) {
    return JSON.stringify({ v: STATE_VERSION, paletteHash: paletteHash, mapping: mapping || {} });
  }

  function parseState(json) {
    var raw;
    try {
      raw = JSON.parse(json);
    } catch (e) {
      return null;
    }
    if (!raw || typeof raw !== 'object') return null;
    if (raw.v !== STATE_VERSION) return null;
    if (typeof raw.paletteHash !== 'string' || !raw.mapping || typeof raw.mapping !== 'object') return null;
    return { paletteHash: raw.paletteHash, mapping: raw.mapping };
  }

  // ---------------------------------------------------------------------
  // layoutHoneycomb — PURE layout for the honeycomb swatch picker (Office-
  // style hex wheel). Places the curated swatch library — and ONLY the
  // curated library; cells are never arbitrary colors — on an axial
  // pointy-top hex grid:
  //
  //   - hue (OKLab atan2(b, a)) -> angular position around the center
  //   - lightness -> ring radius: HIGH L at the center converging toward
  //     white, darker rings outward (rank-based: swatches sorted by L desc
  //     fill ring 0 (1 cell), ring 1 (6), ring 2 (12), ... so the wheel is
  //     always exactly filled from the middle out, no overflow)
  //   - within a ring, swatches sorted by hue are zipped onto the ring's
  //     cells sorted by geometric angle, evenly strided for partial rings,
  //     at the rotation offset minimizing total circular hue-vs-angle error
  //     (ties -> smallest offset). Cyclic hue order inside a ring is thereby
  //     EXACT (no crossings); sparse rings still spread around the wheel
  //     (12-swatch harness) while dense libraries (~100+) tile it like the
  //     reference picker
  //   - NEUTRALS (OKLab chroma < 0.02, where hue is meaningless): a
  //     horizontal strip BELOW the honeycomb (row r = R+2, one blank row of
  //     separation), lightest -> darkest running left -> right — the
  //     documented neutrals choice for this layout
  //   - deterministic AND input-order independent: every stage sorts with
  //     swatch_id as the final tie-break; output is returned in input order
  //
  // Returned cells: {swatch_id, q, r, x, y} with x = sqrt(3)*(q + r/2),
  // y = 1.5*r (unit hex size 1, y grows downward) — the renderer only
  // multiplies by a pixel size and offsets.
  //
  // Math.atan2/hypot are fine HERE: layout is presentation-only and never
  // touches the engine's frozen per-pixel path (no ALGO_VERSION concern).
  // ---------------------------------------------------------------------
  var HONEYCOMB_NEUTRAL_CHROMA = 0.02;
  var SQRT3 = Math.sqrt(3);

  function hexToOklab(hex) {
    var rgb = hexToRgbTriple(hex);
    var out = [0, 0, 0];
    RecolorCore.rgbToOklab(rgb[0], rgb[1], rgb[2], out);
    return out;
  }

  function axialToUnitXY(q, r) {
    return { x: SQRT3 * (q + r / 2), y: 1.5 * r };
  }

  // All cells of hex ring k (k >= 1) around the origin, axial coords.
  function hexRingCells(k) {
    var dirs = [[1, 0], [1, -1], [0, -1], [-1, 0], [-1, 1], [0, 1]];
    var cells = [];
    var q = -k, r = k; // start at the "bottom-left" corner cell
    for (var side = 0; side < 6; side++) {
      for (var step = 0; step < k; step++) {
        cells.push([q, r]);
        q += dirs[side][0];
        r += dirs[side][1];
      }
    }
    return cells;
  }

  function circularDist(a, b) {
    var d = Math.abs(a - b) % (2 * Math.PI);
    return d > Math.PI ? 2 * Math.PI - d : d;
  }

  var VALID_HEX = /^#[0-9a-f]{6}$/i;

  function layoutHoneycomb(swatches) {
    // Defense-in-depth (review FIX 1): a malformed hex in the shop-level
    // swatch metafield (e.g. '#f00', 'red', '', null) would otherwise yield
    // NaN chroma, match NEITHER the chromatic nor the neutral filter, and
    // crash the emit loop — bricking the modal for every customer. Invalid
    // entries are silently skipped; the APA's CRUD paths validate upstream.
    swatches = (swatches || []).filter(function (sw) {
      return sw && typeof sw.hex === 'string' && VALID_HEX.test(sw.hex);
    });
    var enriched = swatches.map(function (sw) {
      var lab = hexToOklab(sw.hex);
      var C = Math.hypot(lab[1], lab[2]);
      var hue = Math.atan2(lab[2], lab[1]);
      if (hue < 0) hue += 2 * Math.PI;
      return { swatch_id: sw.swatch_id, L: lab[0], C: C, hue: hue };
    });

    var chromatic = enriched.filter(function (s) { return s.C >= HONEYCOMB_NEUTRAL_CHROMA; });
    var neutrals = enriched.filter(function (s) { return s.C < HONEYCOMB_NEUTRAL_CHROMA; });

    var placed = {}; // swatch_id -> [q, r]

    // ---- chromatic wheel: rank L desc into rings 0..R, hue-greedy within a ring
    var byLight = chromatic.slice().sort(function (a, b) {
      return b.L - a.L || a.hue - b.hue || (a.swatch_id < b.swatch_id ? -1 : a.swatch_id > b.swatch_id ? 1 : 0);
    });
    var R = 0;
    var offset = 0, ring = 0;
    while (offset < byLight.length) {
      var capacity = ring === 0 ? 1 : 6 * ring;
      var group = byLight.slice(offset, offset + capacity);
      offset += group.length;
      R = ring;
      if (ring === 0) {
        placed[group[0].swatch_id] = [0, 0];
      } else {
        // ring cells with their geometric angles, stable-sorted
        var cells = hexRingCells(ring).map(function (qr) {
          var xy = axialToUnitXY(qr[0], qr[1]);
          var ang = Math.atan2(xy.y, xy.x);
          if (ang < 0) ang += 2 * Math.PI;
          return { q: qr[0], r: qr[1], ang: ang };
        }).sort(function (a, b) { return a.ang - b.ang || a.q - b.q || a.r - b.r; });
        var byHue = group.slice().sort(function (a, b) {
          return a.hue - b.hue || b.L - a.L || (a.swatch_id < b.swatch_id ? -1 : a.swatch_id > b.swatch_id ? 1 : 0);
        });
        // Rotation-zip: swatch j -> cell (k + floor(j*C/m)) mod C for the
        // offset k with the least total circular hue-vs-angle error. This
        // preserves the cyclic hue order exactly and evenly strides sparse
        // groups around the ring.
        var C = cells.length, m = byHue.length;
        var bestK = 0, bestTotal = Infinity;
        for (var k = 0; k < C; k++) {
          var total = 0;
          for (var j = 0; j < m; j++) {
            total += circularDist(byHue[j].hue, cells[(k + Math.floor(j * C / m)) % C].ang);
          }
          if (total < bestTotal - 1e-12) { bestTotal = total; bestK = k; }
        }
        byHue.forEach(function (sw, j) {
          var cell = cells[(bestK + Math.floor(j * C / m)) % C];
          placed[sw.swatch_id] = [cell.q, cell.r];
        });
      }
      ring++;
    }

    // ---- neutral strip: single row below the wheel, light -> dark = left -> right
    if (neutrals.length) {
      var stripR = R + 2; // one blank row between the wheel and the strip
      var sorted = neutrals.slice().sort(function (a, b) {
        return b.L - a.L || (a.swatch_id < b.swatch_id ? -1 : a.swatch_id > b.swatch_id ? 1 : 0);
      });
      // center the strip under the wheel: cell i wants x = sqrt3*(i-(n-1)/2),
      // i.e. q = i - ((n-1)/2 + stripR/2), rounded to the nearest integer cell
      var qShift = Math.round((sorted.length - 1) / 2 + stripR / 2);
      sorted.forEach(function (sw, i) {
        placed[sw.swatch_id] = [i - qShift, stripR];
      });
    }

    // ---- emit in INPUT order
    return swatches.map(function (sw) {
      var qr = placed[sw.swatch_id];
      var xy = axialToUnitXY(qr[0], qr[1]);
      return { swatch_id: sw.swatch_id, q: qr[0], r: qr[1], x: xy.x, y: xy.y };
    });
  }

  // ---------------------------------------------------------------------
  // sortCellsReadingOrder — pure helper for the DOM layer (review FIX 5):
  // sorts layoutHoneycomb cells into SPATIAL reading order (y rows top ->
  // bottom, x left -> right within a row, swatch_id tie-break) so the
  // honeycomb's Tab order walks rows instead of hopping around the wheel
  // in curated-library input order. layoutHoneycomb's emit order remains
  // input order (its tested contract) — buildSwatchGrid applies this sort
  // before creating the cell buttons. Non-mutating.
  // ---------------------------------------------------------------------
  function sortCellsReadingOrder(cells) {
    return (cells || []).slice().sort(function (a, b) {
      return a.y - b.y || a.x - b.x ||
        (a.swatch_id < b.swatch_id ? -1 : a.swatch_id > b.swatch_id ? 1 : 0);
    });
  }

  // ---------------------------------------------------------------------
  // planSizeStep — pure step-flow logic for the "Select Your Size" first
  // step. Input: the ctx.product object. Output {skip, variants, preselected}:
  //   - variants: normalized [{id, title, priceCents, available}] in input
  //     order. Entries with a missing id or non-finite numeric priceCents
  //     are dropped; `available` defaults to true. SOLD-OUT variants are
  //     KEPT (the step renders them greyed + "Sold out", not tappable) and
  //     still count toward the "is there a choice?" threshold.
  //   - exactly ONE variant -> skip:true, preselected = that variant
  //     (single-variant products land straight on colors — no regression);
  //   - NO variants array (a pre-size-step ctx) -> skip:true, preselected =
  //     the ctx fallback {id: variantId, title: null, priceCents, available:
  //     true} — byte-for-byte the old modal behavior;
  //   - 2+ variants -> skip:false, preselected:null (customers actively
  //     choose; nothing is preselected by design).
  // ---------------------------------------------------------------------
  function planSizeStep(product) {
    var raw = (product && product.variants) || [];
    var variants = [];
    for (var i = 0; i < raw.length; i++) {
      var v = raw[i];
      if (!v || v.id === undefined || v.id === null) continue;
      if (typeof v.priceCents !== 'number' || !Number.isFinite(v.priceCents)) continue;
      variants.push({
        id: v.id,
        title: v.title === undefined ? null : v.title,
        priceCents: v.priceCents,
        available: v.available === undefined ? true : !!v.available,
      });
    }
    if (variants.length === 0) {
      return {
        skip: true,
        variants: [],
        preselected: {
          id: product ? product.variantId : undefined,
          title: null,
          priceCents: product ? product.priceCents : undefined,
          available: true,
        },
      };
    }
    if (variants.length === 1) {
      return { skip: true, variants: variants, preselected: variants[0] };
    }
    return { skip: false, variants: variants, preselected: null };
  }

  // ---------------------------------------------------------------------
  // serializeMappingCanonical / approveResultStillValid — pure guards for
  // the in-flight approve race (size-step review FIX 1). The approve POST
  // mints a token for a SNAPSHOT of the mapping; while the POST is in
  // flight the customer can go Back, Change size, or edit swatches. The
  // resolved token may proceed to the cart add ONLY if the approval screen
  // is still the active screen AND the live mapping is still logically
  // identical to the snapshot. Comparison is canonical (family ids sorted
  // numerically) so deleting and re-adding the same entry — same logical
  // mapping, different key insertion order — never discards a valid mint.
  // A discarded mint is safe: the customer just taps Approve again.
  // ---------------------------------------------------------------------
  function serializeMappingCanonical(mapping) {
    mapping = mapping || {};
    var keys = Object.keys(mapping).sort(function (a, b) { return a - b; });
    var parts = [];
    for (var i = 0; i < keys.length; i++) {
      parts.push(JSON.stringify(keys[i]) + ':' + JSON.stringify(mapping[keys[i]]));
    }
    return '{' + parts.join(',') + '}';
  }

  function approveResultStillValid(snapshot, currentMapping, approvalStillActive) {
    if (!approvalStillActive) return false;
    return serializeMappingCanonical(currentMapping) === snapshot;
  }

  // ---------------------------------------------------------------------
  // matchEditVariant — pure guard for the edit flow's variant match
  // (size-step review FIX 2): the ?qfp_recolor_edit path may only jump
  // straight to colors when the cart line's variant exists in the plan AND
  // is still available. A variant that sold out since the line was added
  // returns null, so the open flow lands on the SIZE step instead (mapping
  // still rehydrated; the customer picks an in-stock size to proceed) —
  // otherwise approve would delete the old line and the re-add would 422,
  // permanently losing the customer's line.
  // ---------------------------------------------------------------------
  function matchEditVariant(variants, variantId) {
    if (!variants || variantId === null || variantId === undefined) return null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === variantId) {
        return variants[i].available ? variants[i] : null;
      }
    }
    return null;
  }

  // ---------------------------------------------------------------------
  // COLORWAYS — the 12 fixed one-color looks (recolor-tabs spec §3.2, names
  // and hexes frozen by the spec). Tapping one re-themes EVERY detected
  // family to that hue; an Original tile clears the mapping. The list is a
  // constant (never per-product) so the Colorways tab is identical across
  // the catalog.
  // ---------------------------------------------------------------------
  var COLORWAYS = [
    { id: 'sapphire', name: 'Sapphire', hex: '#1552d8' },
    { id: 'crimson', name: 'Crimson', hex: '#c8102e' },
    { id: 'emerald', name: 'Emerald', hex: '#0a8f4f' },
    { id: 'amethyst', name: 'Amethyst', hex: '#7a2fb0' },
    { id: 'magenta', name: 'Magenta', hex: '#d81b8c' },
    { id: 'teal', name: 'Teal', hex: '#0e7f86' },
    { id: 'tangerine', name: 'Tangerine', hex: '#e2711d' },
    { id: 'sunflower', name: 'Sunflower', hex: '#d9a404' },
    { id: 'rose', name: 'Rose', hex: '#e75480' },
    { id: 'navy', name: 'Navy', hex: '#1b2a6b' },
    { id: 'chocolate', name: 'Chocolate', hex: '#6b4423' },
    { id: 'slate', name: 'Slate', hex: '#5a6472' },
  ];

  // ---------------------------------------------------------------------
  // nearestSwatch — the curated swatch whose OKLab is Euclidean-closest to
  // the given hex. Colorway taps write into S.mapping, and mapping values
  // MUST be curated swatch_ids: the APA approve endpoint hard-rejects any
  // id outside the active RecolorSwatch whitelist (422 swatch_unknown), and
  // the whole downstream pipeline (HMAC'd _recolor_mapping, worker render)
  // resolves targets from swatch rows. So each colorway hue is snapped to
  // its nearest curated swatch — the tile thumbnail renders through the
  // SAME snapped mapping, so what the tile shows is exactly what tapping
  // gives. Invalid-hex library entries are skipped (layoutHoneycomb
  // precedent); ties break on swatch_id so the result is deterministic and
  // input-order independent. Returns a swatch_id, or null when the library
  // has no valid entries.
  // ---------------------------------------------------------------------
  function nearestSwatch(swatches, hex) {
    if (!VALID_HEX.test(String(hex))) return null;
    var target = hexToOklab(hex);
    var bestId = null, bestD = Infinity;
    (swatches || []).forEach(function (sw) {
      if (!sw || typeof sw.hex !== 'string' || !VALID_HEX.test(sw.hex)) return;
      var lab = hexToOklab(sw.hex);
      var dL = lab[0] - target[0], da = lab[1] - target[1], db = lab[2] - target[2];
      var d = dL * dL + da * da + db * db;
      if (d < bestD || (d === bestD && sw.swatch_id < bestId)) {
        bestD = d;
        bestId = sw.swatch_id;
      }
    });
    return bestId;
  }

  // buildColorwayMapping — the {familyId: swatchId} mapping a colorway tap
  // installs. Shape is identical to a hand-built mapping, so every existing
  // consumer (chips, approve payload, localStorage, cart property) works
  // unchanged.
  //
  // NEUTRAL-KEEP (scenic-panel fix, Aaron 2026-07-19): only CHROMATIC
  // families — palette centroid OKLab chroma sqrt(a²+b²) >= COLORWAY_CHROMA_MIN
  // — map to the colorway swatch; neutral families keep their original color.
  // Rationale: on scenic panels (e.g. the Christmas Snow Globes panel, where
  // 7 of 10 families are snow/sky/outline neutrals) the old map-ALL-families
  // behavior dunked the whole image in one hue — snow turned blue. Whites,
  // grays, and blacks are what make a scene readable, so a "one-color look"
  // must re-theme only the colored areas. Edge case: an all-neutral panel
  // maps just the single highest-chroma family (lowest index on exact ties)
  // so the tiles still visibly do something.
  var COLORWAY_CHROMA_MIN = 0.05;

  function buildColorwayMapping(palette, swatchId) {
    var mapping = {};
    if (!palette || swatchId === null || swatchId === undefined) return mapping;
    var K = palette.K;
    if (!(K >= 1)) return mapping;
    var centroids = palette.centroids || [];
    var chroma = [];
    for (var i = 0; i < K; i++) {
      var c = centroids[i];
      chroma.push(c && c.length >= 3 ? Math.hypot(c[1], c[2]) : 0);
    }
    var chromatic = [];
    for (i = 0; i < K; i++) {
      if (chroma[i] >= COLORWAY_CHROMA_MIN) chromatic.push(i);
    }
    if (!chromatic.length) {
      var best = 0;
      for (i = 1; i < K; i++) {
        if (chroma[i] > chroma[best]) best = i; // strict > keeps the lowest index on ties
      }
      chromatic = [best];
    }
    chromatic.forEach(function (fid) { mapping[String(fid)] = swatchId; });
    return mapping;
  }

  // ---------------------------------------------------------------------
  // tablistKeyTarget — pure keyboard logic for the 3-tab bar (spec §3.1:
  // role=tablist, arrow keys). Horizontal tablist per the ARIA APG: Left/
  // Right cycle with wrap-around, Home/End jump to the ends, anything else
  // returns null (caller ignores). Returns the target tab INDEX.
  // ---------------------------------------------------------------------
  function tablistKeyTarget(currentIndex, key, count) {
    if (!(count >= 1)) return null;
    switch (key) {
      case 'ArrowRight': return (currentIndex + 1) % count;
      case 'ArrowLeft': return (currentIndex - 1 + count) % count;
      case 'Home': return 0;
      case 'End': return count - 1;
      default: return null;
    }
  }

  // ---------------------------------------------------------------------
  // EYEDROPPER pure logic (recolor-tabs REVISION 2026-07-19). The eyedropper
  // is a smarter FAMILY SELECTOR, not a new engine mode: the tapped pixel
  // classifies to its color family with the SAME RecolorCore.classify the
  // session/preview already runs — against the ORIGINAL conditioned preview
  // pixels, never the recolored output — and the replacement then rides the
  // exact Choose Colors chip-tap pipeline (S.mapping[family] = target).
  // classify's top-1 index IS the snap rule: a pixel in the soft window /
  // far from every centroid resolves to the nearest family centroid in
  // OKLab (under the session's own w_L-weighted metric) — reused core math,
  // no new constants.
  // ---------------------------------------------------------------------
  function eyedropperFamily(pal, r, g, b) {
    var lab = [0, 0, 0], idx = [0, 0, 0], w = [0, 0, 0];
    RecolorCore.rgbToOklab(r, g, b, lab);
    RecolorCore.classify(lab[0], lab[1], lab[2], pal, idx, w);
    return idx[0];
  }

  // familyMaskChunk — fills out[j] (0/1) for packed 0xRRGGBB pixels in
  // [start, end) with "does this ORIGINAL pixel classify to familyId". memo
  // is a shared Map(packedColor -> top family) so each unique color
  // classifies exactly once across every chunk AND every family highlight
  // (classification is mapping-independent, like the modal's classify
  // pass) — the DOM controller calls this in rAF-sized slices.
  function familyMaskChunk(packed, start, end, pal, familyId, out, memo) {
    for (var j = start; j < end; j++) {
      var p = packed[j];
      var f = memo.get(p);
      if (f === undefined) {
        f = eyedropperFamily(pal, (p >>> 16) & 255, (p >>> 8) & 255, p & 255);
        memo.set(p, f);
      }
      out[j] = f === familyId ? 1 : 0;
    }
  }

  // eyedropperInputAllowed — the REVISION's tab gate: "In this tab only,
  // the preview accepts pointer input". Pure so the gate is testable; the
  // DOM layer additionally hides the overlay on every other tab (defense
  // in depth — a hidden element receives no pointer events anyway).
  function eyedropperInputAllowed(activeTab) {
    return activeTab === 'eyedropper';
  }

  // clampPixel — fractional pointer coords (touch slop can land a hair
  // outside the canvas) -> the integer backing-store pixel they sample.
  function clampPixel(x, y, w, h) {
    var xi = Math.floor(x), yi = Math.floor(y);
    if (xi < 0) xi = 0; else if (xi > w - 1) xi = w - 1;
    if (yi < 0) yi = 0; else if (yi > h - 1) yi = h - 1;
    return { x: xi, y: yi };
  }

  // ---------------------------------------------------------------------
  // Touch magnifier loupe math (REVISION: press-and-drag shows a ~2.5x zoom
  // of the area under the finger, ring marking the exact pixel; the sample
  // is taken on release). Pure geometry only — the DOM layer draws it.
  // Math here is presentation-side (layoutHoneycomb precedent): the loupe
  // never touches the engine's frozen per-pixel path.
  // ---------------------------------------------------------------------
  var LOUPE_ZOOM = 2.5;

  // loupeCenter — where the loupe circle's CENTER goes, in canvas backing
  // px: lifted `lift` px above the finger so the finger doesn't cover it,
  // flipped BELOW when that would poke past the top edge, then clamped so
  // the full d-diameter circle stays on-canvas.
  function loupeCenter(px, py, w, h, d, lift) {
    var r = d / 2;
    var cy = py - lift - r;
    if (cy < r) cy = py + lift + r; // near the top edge: flip below the finger
    if (cy > h - r) cy = h - r;
    if (cy < r) cy = r;
    var cx = px < r ? r : (px > w - r ? w - r : px);
    return { x: cx, y: cy };
  }

  // loupeTransform — the setTransform(zoom,0,0,zoom,dx,dy) translate that
  // lands source pixel (px,py) exactly on the loupe center (cx,cy), so the
  // ring always marks the pixel that will be sampled on release.
  function loupeTransform(px, py, cx, cy, zoom) {
    return { dx: cx - zoom * px, dy: cy - zoom * py };
  }

  // ---------------------------------------------------------------------
  // eyedropSelectionView — pure derivation of the eyedropper panel's
  // "Selected:" line from S.selectedFamily (adversarial-review finding
  // 1+2): the panel must DERIVE from the ONE source of truth and never
  // keep a lastFamily copy of its own — a Choose Colors chip tap, a sample
  // here, and the rebuild default all funnel through selectFamily, and the
  // panel just mirrors it. `family` is also the family the highlight
  // overlay shows, so the label, the highlight, and the family a honeycomb
  // tap recolors can never disagree.
  //
  // Re-change affordance (Task 4, 65+ brief): when the selected family is
  // ALREADY MAPPED the line shows BOTH states in plain words — "Selected:
  // Red — currently Deep Blue" with both swatch squares — so re-selecting
  // a changed area (or tapping its chip) visibly says "you are adjusting
  // an existing change", and the next swatch pick overwrites it.
  //   mapped:false → label 'Selected: Color N', currentHex/currentName null
  //   mapped:true  → originalName from familyColorName(ui_hex), currentHex/
  //                  currentName from the mapped curated swatch, label the
  //                  full sentence (also what the DOM composes around the
  //                  two squares)
  // ---------------------------------------------------------------------
  function eyedropSelectionView(selectedFamily, uiHex, mapping, swatches) {
    if (selectedFamily === null || selectedFamily === undefined) {
      return { visible: false, family: null, label: '', swatchHex: null, mapped: false, originalName: null, currentHex: null, currentName: null };
    }
    var swatchHex = (uiHex && uiHex[selectedFamily]) || '#ccc';
    var swatchId = mapping ? mapping[String(selectedFamily)] : undefined;
    if (swatchId === undefined) {
      return {
        visible: true,
        family: selectedFamily,
        label: 'Selected: Color ' + (selectedFamily + 1),
        swatchHex: swatchHex,
        mapped: false, originalName: null, currentHex: null, currentName: null,
      };
    }
    swatches = swatches || [];
    var currentHex = null;
    for (var s = 0; s < swatches.length; s++) {
      if (swatches[s].swatch_id === swatchId) { currentHex = swatches[s].hex; break; }
    }
    var originalName = familyColorName(swatchHex);
    var currentName = swatchName(swatches, swatchId);
    return {
      visible: true,
      family: selectedFamily,
      label: 'Selected: ' + originalName + ' — currently ' + currentName,
      swatchHex: swatchHex,
      mapped: true,
      originalName: originalName,
      currentHex: currentHex || '#fff',
      currentName: currentName,
    };
  }

  // ---------------------------------------------------------------------
  // eyedropReleaseSamples — pure pointerup gate (adversarial-review
  // findings 3+4): a touch release takes the sample ONLY when
  //   (a) the eyedropper tab is STILL the active tab — a mid-drag tab
  //       switch aborts instead of sampling into whatever tab now shows;
  //   (b) the release point is still on the canvas — the customer's
  //       natural slide-off-to-abort gesture cancels instead of sampling
  //       a clamped border pixel.
  // Coords are backing px exactly as eyedropCoords produces them
  // (unclamped — pointer capture keeps events flowing off-canvas). The
  // [0,w]x[0,h] bound is inclusive: an exact-edge release still resolves
  // to a real pixel via clampPixel; anything past the edge cancels.
  // ---------------------------------------------------------------------
  function eyedropReleaseSamples(activeTab, x, y, w, h) {
    return eyedropperInputAllowed(activeTab) &&
      x >= 0 && x <= w && y >= 0 && y <= h;
  }

  // ---------------------------------------------------------------------
  // createEyedropHighlight — visibility lifetime of the 45% white family
  // highlight (adversarial-review finding 5; spec intent "highlight for
  // ~1.5s or until action"). The overlay washes out exactly the area the
  // customer needs to judge, so it shows for EYEDROP_HILITE_MS after a
  // sample (or a tab re-activation — brief orientation), then auto-clears;
  // applying a color clears it IMMEDIATELY. One-shot injectable timers
  // (never setInterval, never Date.now) keep the logic pure/testable; the
  // DOM passes real setTimeout/clearTimeout and re-renders the overlay in
  // onChange. clear() also cancels any pending timer, so tab switches and
  // modal closes are leak-free by construction.
  // ---------------------------------------------------------------------
  var EYEDROP_HILITE_MS = 1500;

  function createEyedropHighlight(setTimeoutFn, clearTimeoutFn, onChange) {
    var timer = null, visible = false;
    function cancelTimer() {
      if (timer !== null) { clearTimeoutFn(timer); timer = null; }
    }
    function setVisible(v) {
      if (visible === v) return;
      visible = v;
      onChange(v);
    }
    return {
      visible: function () { return visible; },
      // A sample landed / the tab re-activated: show and (re)start the
      // one-shot — repeated samples keep exactly one pending timer.
      show: function () {
        cancelTimer();
        timer = setTimeoutFn(function () { timer = null; setVisible(false); }, EYEDROP_HILITE_MS);
        setVisible(true);
      },
      // A color was applied / the tab switched away / the modal closed:
      // clear NOW and drop the pending timer.
      clear: function () {
        cancelTimer();
        setVisible(false);
      },
    };
  }

  // ---------------------------------------------------------------------
  // eyedropHoverShowsLoupe — desktop hover magnifier gate (Aaron: "when you
  // hover over the picture can you have like a magnifying glass show up to
  // help pick the right color"). The SAME touch loupe follows a MOUSE
  // pointer hovering the preview — but only in the Tap to Change tab, only
  // for a real mouse (touch keeps its press-drag loupe; pen keeps its
  // click-samples-immediately behavior), and only with NO button held (a
  // pressed button means the click's sample is in flight — the loupe hides
  // during/after it and the next hover move re-shows it).
  // ---------------------------------------------------------------------
  function eyedropHoverShowsLoupe(activeTab, pointerType, buttons) {
    return eyedropperInputAllowed(activeTab) && pointerType === 'mouse' && buttons === 0;
  }

  // ---------------------------------------------------------------------
  // Tap to Change panel copy (65+ design brief, Aaron 2026-07-19: "I can't
  // tell that I can do multiple colors when I used it... We need to make it
  // for a sixty five plus demographic"). Always-visible 1-2-3 instructions
  // in plain words — pure data so the copy is pinned by tests; the DOM
  // renders them. (A post-apply "✓ Done!" confirmation line existed
  // briefly; Aaron had it removed 2026-07-19 — the selected line + changes
  // list are the apply feedback.)
  // ---------------------------------------------------------------------
  var EYEDROP_INSTRUCTIONS = [
    'Tap any color on the picture.',
    'Choose its new color.',
    'Repeat for as many colors as you like — you can change any color again at any time.',
  ];

  // ---------------------------------------------------------------------
  // familyColorName — plain-language name for a family's ORIGINAL color
  // (65+ design brief: chips must read like "Red → Navy Blue", and remove
  // buttons like "Remove: Red back to original" — never internal ids like
  // C104 or a bare "Color 3"). Presentation-only naming from the family's
  // ui_hex via OKLab (layoutHoneycomb precedent — never touches the
  // engine's frozen path): low-chroma colors bucket to White/Gray/Black by
  // lightness, chromatic colors bucket by OKLab hue angle with Light/Dark
  // modifiers (Brown is dark orange). Two families can share a name — every
  // rendered reference pairs the name with the family's visible swatch
  // square, which disambiguates.
  // ---------------------------------------------------------------------
  var FAMILY_NAME_NEUTRAL_CHROMA = 0.04;

  function familyColorName(hex) {
    if (!VALID_HEX.test(String(hex))) return 'This color';
    var lab = hexToOklab(hex);
    var L = lab[0], C = Math.hypot(lab[1], lab[2]);
    if (C < FAMILY_NAME_NEUTRAL_CHROMA) {
      if (L >= 0.93) return 'White';
      if (L >= 0.7) return 'Light Gray';
      if (L >= 0.45) return 'Gray';
      if (L >= 0.25) return 'Dark Gray';
      return 'Black';
    }
    var hue = Math.atan2(lab[2], lab[1]) * 180 / Math.PI;
    if (hue < 0) hue += 360;
    var base;
    if (hue >= 330 || hue < 20) base = 'Pink';
    else if (hue < 50) base = 'Red';
    else if (hue < 80) base = L < 0.55 ? 'Brown' : 'Orange';
    else if (hue < 115) base = 'Yellow';
    else if (hue < 175) base = 'Green';
    else if (hue < 215) base = 'Teal';
    else if (hue < 285) base = 'Blue';
    else base = 'Purple';
    if (base !== 'Brown') {
      if (L >= 0.82) base = 'Light ' + base;
      else if (L <= 0.35) base = 'Dark ' + base;
    }
    return base;
  }

  // ---------------------------------------------------------------------
  // eyedropChangesView — pure derivation of the "Your color changes" list
  // from S.mapping, the ONE source of truth (so it includes changes made in
  // ANY tab: chips, colorways, presets, or Tap to Change samples). One
  // entry per currently-mapped family, ascending numeric family id (same
  // deterministic order summary() uses): original swatch square + plain
  // name → new swatch square + curated name, plus the accessible remove
  // label AND the chip-body edit label (Task 4: the chip body is a tap
  // target — "Change Red again" — that re-selects the family exactly like
  // re-sampling it, so a prior change can be adjusted from the list).
  // Empty mapping → the list hides. The remove action itself is the Choose
  // Colors un-map path (selectFamily + onSwatchTap(null)) — this view
  // never mutates anything.
  // ---------------------------------------------------------------------
  function eyedropChangesView(mapping, uiHex, swatches) {
    mapping = mapping || {};
    swatches = swatches || [];
    var familyIds = Object.keys(mapping).map(Number).sort(function (a, b) { return a - b; });
    var entries = familyIds.map(function (fid) {
      var swatchId = mapping[String(fid)];
      var toHex = null;
      for (var s = 0; s < swatches.length; s++) {
        if (swatches[s].swatch_id === swatchId) { toHex = swatches[s].hex; break; }
      }
      var fromHex = (uiHex && uiHex[fid]) || '#cccccc'; // 6-digit so familyColorName can read it
      var fromName = familyColorName(fromHex);
      return {
        family: fid,
        fromHex: fromHex,
        fromName: fromName,
        toHex: toHex || '#fff',
        toName: swatchName(swatches, swatchId),
        editLabel: 'Change ' + fromName + ' again',
        removeLabel: 'Remove: ' + fromName + ' back to original',
      };
    });
    return { visible: entries.length > 0, entries: entries };
  }

  // ---------------------------------------------------------------------
  // _dom — the modal controller (Task 2). Drives the shell markup rendered
  // by theme/snippets/custom-colors.liquid (mirrored by theme/harness/
  // index.html): open → lazy preview load + classify pass (spinner) →
  // family chips / swatch taps (session.prepare + mapWith, rAF-coalesced)
  // → presets → Reset → price footer + ΔE warnings → approval screen →
  // toBlob multipart approve POST → /cart/add.js with the frozen cart
  // properties. Also: localStorage persistence, pageshow canvas rebuild,
  // ?qfp_recolor_edit=<line> rehydrate hook, window.qfpRecolorLastPayload
  // test hook.
  //
  // Canvas discipline (spec §6): backing store at ASSET resolution (1200
  // asset for viewports <=768px else 1600 — pickAssetSize), CSS-scaled,
  // devicePixelRatio deliberately ignored; 2d contexts created with
  // {colorSpace:'srgb', willReadFrequently:true} so getImageData bytes are
  // the same sRGB bytes the engine's LUT expects.
  // ---------------------------------------------------------------------
  var APPROVE_MAX_PREVIEW_PX = 600;          // frozen contract: preview_jpeg <=600px longest side
  var APPROVE_JPEG_QUALITY = 0.8;            // frozen contract: toBlob('image/jpeg', 0.8)
  var APPROVE_MAX_PREVIEW_BYTES = 300 * 1024; // frozen contract: <=300KB (APA hard-rejects above)
  var CANONICAL_FID = /^(0|[1-9]\d*)$/;

  var _dom = (function () {
    var S = null; // singleton controller state (one modal per product page)

    // Shell elements the container MUST provide, as [data-qfp-cc="<name>"].
    var EL_NAMES = [
      'open', 'overlay', 'close', 'spinner', 'spinner-msg', 'body', 'subtitle',
      'size', 'size-sub', 'size-list', 'size-line', 'size-chosen', 'size-change',
      'tabbar', 'tab-choose', 'tab-colorways', 'tab-eyedropper',
      'panel-choose', 'panel-colorways', 'panel-eyedropper', 'colorways', 'eyedropper-root',
      'canvas', 'chips', 'swatches', 'swatch-label', 'presets-row', 'presets',
      'warnings', 'price', 'summary', 'reset', 'continue',
      'approval', 'approval-canvas', 'approval-price', 'approval-check',
      'approval-status', 'approval-back', 'approve',
      'success', 'success-summary', 'success-close',
    ];

    // Tab ids in visual order (spec §3.1). Shell markup provides one
    // [data-qfp-cc="tab-<id>"] button + one [data-qfp-cc="panel-<id>"]
    // tabpanel per entry; 'eyedropper' builds into its panel's empty
    // [data-qfp-cc="eyedropper-root"] mount (buildEyedropperUi).
    var TAB_IDS = ['choose', 'colorways', 'eyedropper'];

    function camel(s) { return s.replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); }); }

    function collect(container) {
      var els = {};
      for (var i = 0; i < EL_NAMES.length; i++) {
        var node = container.querySelector('[data-qfp-cc="' + EL_NAMES[i] + '"]');
        if (!node) throw new Error('recolor-ui: missing [data-qfp-cc="' + EL_NAMES[i] + '"] in container');
        els[camel(EL_NAMES[i])] = node;
      }
      return els;
    }

    function el(tag, className, text) {
      var n = document.createElement(tag);
      if (className) n.className = className;
      if (text !== undefined) n.textContent = text;
      return n;
    }

    function show(n) { n.hidden = false; }
    function hide(n) { n.hidden = true; }
    function now() { return (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now(); }

    function setStatus(node, msg, isError) {
      node.hidden = !msg;
      node.textContent = msg || '';
      node.classList.toggle('qfp-cc-status--error', !!isError);
    }

    // ---- init ------------------------------------------------------------
    function init(container, ctx) {
      if (S) throw new Error('recolor-ui: _dom.init called twice');
      if (!container || !ctx) throw new Error('recolor-ui: init(container, ctx) requires both arguments');
      if (!ctx.palette || !ctx.palette.palette_hash || !(ctx.palette.K >= 1)) throw new Error('recolor-ui: ctx.palette missing/invalid');
      if (!Array.isArray(ctx.swatches) || !ctx.swatches.length) throw new Error('recolor-ui: ctx.swatches missing/empty');
      if (!ctx.product || ctx.product.id === undefined || ctx.product.variantId === undefined) throw new Error('recolor-ui: ctx.product needs id + variantId');
      if (typeof ctx.product.priceCents !== 'number' || !Number.isFinite(ctx.product.priceCents)) throw new Error('recolor-ui: ctx.product.priceCents must be integer cents');
      if (!ctx.previewUrls || typeof ctx.previewUrls !== 'object') throw new Error('recolor-ui: ctx.previewUrls missing');

      var els = collect(container);

      var swatchById = {};
      for (var i = 0; i < ctx.swatches.length; i++) swatchById[ctx.swatches[i].swatch_id] = ctx.swatches[i];

      S = {
        ctx: ctx,
        els: els,
        swatchById: swatchById,
        familyOrder: familyOrder(ctx.palette),
        presets: [],
        mapping: {},
        selectedFamily: null,
        session: null,
        img: null,
        packed: null,      // Int32Array of packed 0xRRGGBB source pixels
        outData: null,     // ImageData written every repaint
        out32: null,       // little-endian Uint32 view over outData (fast path)
        c2d: null,
        canvas: els.canvas,
        uniqueColors: 0,
        loaded: false,
        open: false,
        disabled: false,
        repaintQueued: false,
        historyPushed: false,
        approved: null,        // {token, previewUrl} once the APA minted one
        editLine: null,        // 1-based cart line being REPLACED (edit-colors mode)
        pendingEditMapping: null,
        pendingEditVariantId: null, // the edited line's variant: same size, straight to colors
        plan: planSizeStep(ctx.product), // "Select Your Size" step plan (pure, tested)
        chosenVariant: null,   // drives the price footer + the /cart/add.js variant id
        colorUiBuilt: false,   // color step built lazily on first entry per open
        chipEls: {},
        swatchEls: [],
        activeTab: 'choose',   // current color-step tab (spec §3.1; reset per rebuild)
        colorwayEls: [],       // [{cwId, btn, canvas, mapping}] — mapping null = Original tile
        colorwayThumbsStarted: false, // lazy thumb chain runs ONCE per color-UI build
        eyedrop: null,         // persistent eyedropper state (family memo/highlight cache/selection), built once post-load
        eyedropEls: null,      // eyedropper-tab DOM refs, rebuilt per color-UI build (buildEyedropperUi)
        eyedropCueShown: false, // one-time "tap the picture" attention pulse, once per modal open (65+ brief)
      };
      S.presets = normalizePresets(ctx.presets);

      // Family-highlight lifetime driver (review finding 5): the pure
      // createEyedropHighlight state machine wired to real one-shot timers;
      // every visibility flip just re-renders the overlay.
      S.eyedropHilite = createEyedropHighlight(
        function (fn, ms) { return setTimeout(fn, ms); },
        function (id) { clearTimeout(id); },
        function () { renderEyedropOverlay(); }
      );

      // Modal escapes any parent overflow/transform (custom-panel-size precedent).
      document.body.appendChild(els.overlay);

      els.open.addEventListener('click', function () { openModal(); });
      els.close.addEventListener('click', function () { closeModal(false); });
      els.overlay.addEventListener('click', function (e) { if (e.target === els.overlay) closeModal(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && S.open) closeModal(false); });
      window.addEventListener('popstate', function () {
        if (S.open) { S.historyPushed = false; closeModal(true); }
      });
      // bfcache restore / tab re-show can blank the canvas backing store —
      // rebuild from the retained pixel state (spec §6).
      window.addEventListener('pageshow', function (e) {
        if (e.persisted && S.open && S.loaded) scheduleRepaint('pageshow canvas rebuild');
      });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && S.open && S.loaded) scheduleRepaint('visibility canvas rebuild');
      });

      // Tab bar (spec §3.1): click selects; Left/Right/Home/End move focus AND
      // select (automatic activation per the ARIA APG — tablistKeyTarget is the
      // pure, tested key logic). Switching tabs NEVER touches S.mapping —
      // panels are only shown/hidden.
      TAB_IDS.forEach(function (tabId, idx) {
        var btn = tabEl(tabId);
        btn.addEventListener('click', function () { selectTab(tabId); });
        btn.addEventListener('keydown', function (e) {
          var t = tablistKeyTarget(idx, e.key, TAB_IDS.length);
          if (t === null) return;
          e.preventDefault();
          selectTab(TAB_IDS[t]);
          tabEl(TAB_IDS[t]).focus();
        });
      });

      els.reset.addEventListener('click', resetAll);
      els.sizeChange.addEventListener('click', function () { showSizeStep(); });
      els.continue.addEventListener('click', function () {
        if (Object.keys(S.mapping).length) showApproval();
      });
      // The eyedropper overlay is CSS-scaled over the preview canvas — keep
      // its geometry glued to the canvas through viewport resizes/rotations.
      window.addEventListener('resize', function () { if (S.open) syncEyedropperOverlay(); });
      els.approvalBack.addEventListener('click', function () { hide(els.approval); show(els.body); });
      els.approvalCheck.addEventListener('change', refreshApproveButton);
      els.approve.addEventListener('click', onApproveClick);
      els.successClose.addEventListener('click', function () { closeModal(false); });

      els.subtitle.textContent = ctx.product.title || '';

      // Feature-detect passed upstream (snippet boot script) — reveal the button.
      els.open.hidden = false;

      // Debug/verification hook (read-only snapshot; test hook proper is
      // window.qfpRecolorLastPayload, set right before the cart add fetch).
      window.qfpRecolorDebug = {
        getState: function () {
          return {
            open: S.open, loaded: S.loaded, disabled: S.disabled,
            mapping: JSON.parse(JSON.stringify(S.mapping)),
            selectedFamily: S.selectedFamily,
            approved: S.approved ? { token: S.approved.token, previewUrl: S.approved.previewUrl } : null,
            editLine: S.editLine,
            chosenVariant: S.chosenVariant ? { id: S.chosenVariant.id, title: S.chosenVariant.title, priceCents: S.chosenVariant.priceCents } : null,
            sizeStep: { skip: S.plan.skip, variantCount: S.plan.variants.length },
            uniqueColors: S.uniqueColors,
            familyOrder: S.familyOrder.slice(),
            presets: S.presets.length,
            activeTab: S.activeTab,
            colorways: S.colorwayEls.length,
            eyedropFamily: S.eyedrop ? S.selectedFamily : null, // panel derives from selectedFamily (review finding 1+2)
            eyedropCachedFamilies: S.eyedrop ? Object.keys(S.eyedrop.maskCache).length : 0,
          };
        },
      };

      maybeEditRehydrate();
      return S;
    }

    // ---- open/close --------------------------------------------------------
    function openModal() {
      if (S.disabled || S.open) return;
      S.open = true;
      S.els.overlay.classList.add('qfp-cc-on');
      document.body.style.overflow = 'hidden';
      S.els.spinnerMsg.textContent = 'Preparing your fabric preview…';
      S.els.spinnerMsg.classList.remove('qfp-cc-status--error');
      var spinEl = S.els.spinner.querySelector('.qfp-cc-spin');
      if (spinEl) spinEl.hidden = false; // re-arm after a previous error open hid it (FIX 2)
      show(S.els.spinner); hide(S.els.size); hide(S.els.body); hide(S.els.approval); hide(S.els.success);
      try { history.pushState({ qfpRecolor: true }, ''); S.historyPushed = true; } catch (e) { S.historyPushed = false; }

      S.colorUiBuilt = false; // color UI rebuilds on first color-step entry each open
      S.eyedropCueShown = false; // the tap-the-picture pulse re-arms once per open

      var ready = S.loaded ? Promise.resolve() : loadAndClassify();
      ready.then(function () {
        restoreSavedState();
        if (S.pendingEditMapping) { S.mapping = S.pendingEditMapping; S.pendingEditMapping = null; }
        hide(S.els.spinner);
        // "Select Your Size" is the FIRST step. Straight-to-colors paths:
        //  - single-variant / no-variants products (plan.skip — no regression),
        //  - edit-colors reopen whose cart line variant matches (same size).
        // Otherwise the size step shows on EVERY open: customers actively
        // choose (nothing preselected by design; a previous pick is only
        // highlighted, never auto-advanced).
        // matchEditVariant (pure, tested) returns null for a variant that has
        // SOLD OUT since the line was added — the flow then lands on the size
        // step (mapping already rehydrated above) instead of letting approve
        // delete the old line and 422 on the re-add (review FIX 2).
        var editVariant = matchEditVariant(S.plan.variants, S.pendingEditVariantId);
        S.pendingEditVariantId = null;
        if (S.plan.skip) {
          S.chosenVariant = S.plan.preselected;
          showColorStep();
        } else if (editVariant) {
          S.chosenVariant = editVariant;
          showColorStep();
        } else {
          showSizeStep();
        }
      }).catch(function (err) {
        console.error('[qfp-recolor] open failed:', err);
        // Review FIX 2: a BUILD-phase failure lands here after the body was
        // already shown — re-show the message container (and hide the
        // half-built body/size step) so the customer sees the error, not a
        // silently broken modal. The spin animation is hidden so it doesn't
        // imply "still loading" under an error message (openModal re-shows it).
        hide(S.els.body);
        hide(S.els.size);
        show(S.els.spinner);
        var spin = S.els.spinner.querySelector('.qfp-cc-spin');
        if (spin) spin.hidden = true;
        S.els.spinnerMsg.textContent = 'The preview could not be loaded — please close and try again.';
        S.els.spinnerMsg.classList.add('qfp-cc-status--error');
      });
    }

    function closeModal(fromPop) {
      if (!S.open) return;
      S.open = false;
      // Eyedropper hygiene (review findings 4+5): a close mid-press must not
      // leave a tracking loupe/pointer capture behind, and the highlight's
      // pending one-shot timer is dropped (leak-free across opens).
      cancelEyedropTracking();
      if (S.eyedropHilite) S.eyedropHilite.clear();
      S.els.overlay.classList.remove('qfp-cc-on');
      document.body.style.overflow = '';
      if (!fromPop && S.historyPushed) {
        S.historyPushed = false;
        try { history.back(); } catch (e) { /* no-op */ }
      }
    }

    function disableFeature() {
      S.disabled = true;
      closeModal(false);
      S.els.open.hidden = true;
    }

    // ---- "Select Your Size" step (feature: size-step) -----------------------
    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function currentPriceCents() {
      return S.chosenVariant ? S.chosenVariant.priceCents : S.ctx.product.priceCents;
    }

    function showSizeStep() {
      hide(S.els.body); hide(S.els.approval); hide(S.els.success);
      S.els.sizeSub.textContent = S.ctx.product.title || '';
      buildSizeList();
      show(S.els.size);
      // Modal focus discipline (review P2): focus the first tappable size,
      // falling back to the step heading when everything is sold out.
      var first = S.els.sizeList.querySelector('button:enabled');
      var target = first || S.els.size.querySelector('.qfp-cc-title');
      if (target && target.focus) target.focus();
    }

    function buildSizeList() {
      var box = S.els.sizeList;
      box.textContent = '';
      var anyAvailable = false;
      S.plan.variants.forEach(function (v) {
        var btn = el('button', 'qfp-cc-size-btn');
        btn.type = 'button';
        btn.setAttribute('data-variant', String(v.id));
        var label = v.title === null ? 'Size' : v.title;
        btn.appendChild(el('span', 'qfp-cc-size-btn-title', label));
        if (v.available) {
          anyAvailable = true;
          btn.appendChild(el('span', 'qfp-cc-size-btn-price', money(v.priceCents)));
          btn.setAttribute('aria-label', label + ' — ' + money(v.priceCents));
          btn.addEventListener('click', function () { chooseSize(v); });
        } else {
          btn.appendChild(el('span', 'qfp-cc-size-soldout', 'Sold out'));
          btn.setAttribute('aria-label', label + ' — Sold out');
          btn.disabled = true;
        }
        // review P3: the previous pick must not be visual-only
        var chosen = !!(S.chosenVariant && S.chosenVariant.id === v.id);
        btn.setAttribute('aria-pressed', chosen ? 'true' : 'false');
        btn.classList.toggle('qfp-cc-size-btn--chosen', chosen);
        box.appendChild(btn);
      });
      // review P1: an all-sold-out product must not be a silent dead end
      if (S.plan.variants.length && !anyAvailable) {
        box.appendChild(el('p', 'qfp-cc-size-empty', 'All sizes are currently sold out.'));
      }
    }

    // Tapping a size ADVANCES immediately (no separate Continue). Mappings
    // and any minted approval survive size changes: the approve token is
    // mapping-scoped (no variant in the approve contract), so only the
    // price footer and the /cart/add.js variant id change.
    function chooseSize(v) {
      S.chosenVariant = v;
      showColorStep();
    }

    function showColorStep() {
      hide(S.els.size); hide(S.els.approval); hide(S.els.success);
      // Body first: the honeycomb sizes itself from the (now measurable)
      // container width — building while display:none reads clientWidth 0.
      show(S.els.body);
      if (!S.colorUiBuilt) {
        // Rebuild always lands on Choose Colors: buildSwatchGrid measures its
        // panel's clientWidth/Height, so that panel must be the visible one
        // while building. Tab choice persists across switches WITHIN an open
        // (spec §3.1 persistence is about the mapping, not the active tab).
        selectTab('choose');
        buildChips();
        buildSwatchGrid();
        buildColorways();
        buildPresets();
        buildEyedropperUi();
        selectFamily(S.familyOrder.length ? S.familyOrder[0] : null);
        S.colorUiBuilt = true;
        repaint('open repaint');
      }
      updateSizeLine();
      updateMeta();
      // Modal focus discipline (review P2): announce the step change.
      var heading = S.els.body.querySelector('.qfp-cc-title');
      if (heading && heading.focus) heading.focus();
    }

    // "Size: 10" x 10" — $7.99  [Change size]" line in the color-step header.
    // Hidden on the skip paths (single-variant / no-variants products have no
    // size step to return to).
    function updateSizeLine() {
      var lineEl = S.els.sizeLine;
      if (S.plan.skip || !S.chosenVariant || S.chosenVariant.title === null) {
        lineEl.hidden = true;
        return;
      }
      S.els.sizeChosen.textContent = 'Size: ' + S.chosenVariant.title + ' — ' + money(S.chosenVariant.priceCents);
      lineEl.hidden = false;
    }

    // ---- color-step tab bar (feature: recolor-tabs §3.1) --------------------
    // Three modes over ONE shared state: Choose Colors (chips+honeycomb),
    // Colorways (one-color looks + suggested combos), Eyedropper (tap the
    // preview to pick the family — REVISION 2026-07-19). Panels are static
    // shell markup; selecting a tab toggles aria-selected + roving tabindex
    // on the buttons and [hidden] on the panels — state is NEVER discarded
    // by a switch.
    function tabEl(tabId) { return S.els[camel('tab-' + tabId)]; }
    function panelEl(tabId) { return S.els[camel('panel-' + tabId)]; }

    function selectTab(tabId) {
      S.activeTab = tabId;
      TAB_IDS.forEach(function (id) {
        var active = id === tabId;
        var btn = tabEl(id);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        btn.tabIndex = active ? 0 : -1;
        panelEl(id).hidden = !active;
      });
      onTabActivated(tabId);
    }

    // Tab-activation hook — the ONE place per-tab work hangs off a switch.
    // Also dispatched as a bubbling 'qfp-cc:tab-change' CustomEvent on the
    // tab bar so later builders can listen without editing this function.
    function onTabActivated(tabId) {
      if (tabId === 'colorways') ensureColorwayThumbs();
      // Eyedropper: the tab shell is built with the rest of the color UI
      // (buildEyedropperUi in showColorStep); activation re-derives the
      // panel from S.selectedFamily (review finding 1+2 — entering the tab
      // must always show the TRUE current target family, whichever tab last
      // changed it) and finishes any deferred picker build (the honeycomb
      // can only size itself while its panel is visible/measurable). The
      // family highlight re-shows briefly for orientation (finding 5 —
      // same ~1.5s auto-clear as a sample).
      if (tabId === 'eyedropper') {
        renderEyedropSelection();
        if (S.eyedrop && S.selectedFamily !== null) {
          S.eyedropHilite.show();
          buildFamilyHighlight(S.selectedFamily);
        }
        // One-time gentle attention cue (65+ brief item 5): a brief ~2s
        // pulse on the preview overlay the FIRST time this tab opens per
        // modal open, drawing the eye to "tap the picture". Pure CSS
        // animation (no rAF loop); the class is dropped after it finishes
        // so a later rebuild never replays it mid-session.
        if (!S.eyedropCueShown && S.eyedropEls) {
          S.eyedropCueShown = true;
          var cueEl = S.eyedropEls.overlay;
          cueEl.classList.add('qfp-cc-eyedrop-cue');
          setTimeout(function () { cueEl.classList.remove('qfp-cc-eyedrop-cue'); }, 2200);
        }
      } else {
        // Leaving the tab: abort any in-flight touch press (finding 4 — the
        // eventual pointerup must not sample into another tab) and clear the
        // highlight + its pending timer (finding 5 — no leaks across tabs).
        cancelEyedropTracking();
        if (S.eyedropHilite) S.eyedropHilite.clear();
      }
      syncEyedropperOverlay();
      try {
        S.els.tabbar.dispatchEvent(new CustomEvent('qfp-cc:tab-change', { bubbles: true, detail: { tab: tabId } }));
      } catch (e) { /* ancient CustomEvent — the hook is progressive enhancement */ }
    }

    // ---- preview load + classify pass -------------------------------------
    function loadImage(url) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = 'anonymous'; // Shopify Files CDN sends CORS headers; required for getImageData
        img.onload = function () { resolve(img); };
        img.onerror = function () { reject(new Error('preview image failed to load: ' + url)); };
        img.src = url;
      });
    }

    function loadAndClassify() {
      var t0 = now();
      var size = pickAssetSize(window.innerWidth);
      var url = S.ctx.previewUrls[String(size)] || S.ctx.previewUrls[String(size === 1200 ? 1600 : 1200)];
      if (!url) return Promise.reject(new Error('no preview URL for asset size ' + size));

      return loadImage(url).then(function (img) {
        S.img = img;
        var w = img.naturalWidth, h = img.naturalHeight;
        // Backing store at asset resolution; CSS scales the element. Never
        // multiply by devicePixelRatio (determinism > sharpness — spec §6).
        S.canvas.width = w;
        S.canvas.height = h;
        S.c2d = S.canvas.getContext('2d', { colorSpace: 'srgb', willReadFrequently: true });
        S.c2d.drawImage(img, 0, 0);
        var srcData = S.c2d.getImageData(0, 0, w, h);

        var n = w * h, d = srcData.data;
        S.packed = new Int32Array(n);
        for (var bi = 0, j = 0; j < n; bi += 4, j++) {
          S.packed[j] = (d[bi] << 16) | (d[bi + 1] << 8) | d[bi + 2];
        }
        // Reuse the ImageData as the repaint output buffer (every repaint
        // recomputes all pixels from S.packed, so source bytes aren't needed).
        S.outData = srcData;
        S.out32 = null;
        try {
          var probe = new Uint32Array(new Uint8Array([1, 2, 3, 4]).buffer);
          if (probe[0] === 0x04030201) S.out32 = new Uint32Array(srcData.data.buffer);
        } catch (e) { S.out32 = null; }

        S.session = RecolorCore.createClassifiedSession(S.ctx.palette);

        // Classify pass (spec §4.3): classification is mapping-independent,
        // so warm every unique color's entry ONCE here, inside the spinner —
        // swatch taps afterwards re-run only the transfer.
        var t1 = now();
        var prep = S.session.prepare({});
        var seen = new Map();
        for (var k = 0; k < n; k++) {
          var p = S.packed[k];
          if (!seen.has(p)) {
            seen.set(p, 1);
            S.session.mapWith(prep, (p >>> 16) & 255, (p >>> 8) & 255, p & 255);
          }
        }
        S.uniqueColors = seen.size;
        S.loaded = true;
        console.log('[qfp-recolor] preview ' + w + 'x' + h + ' loaded in ' + (t1 - t0).toFixed(0) +
          'ms; classify pass ' + (now() - t1).toFixed(0) + 'ms (' + seen.size + ' unique colors)');
      });
    }

    // ---- repaint (session.prepare + mapWith, rAF-coalesced) ----------------
    function targetsFromMapping(mapping) {
      var targets = {};
      for (var fid in mapping) {
        if (!Object.prototype.hasOwnProperty.call(mapping, fid)) continue;
        var sw = S.swatchById[mapping[fid]];
        if (sw) targets[fid] = hexToOklab(sw.hex);
      }
      return targets;
    }

    function repaint(reason) {
      if (!S.loaded) return;
      var t0 = now();
      var prep = S.session.prepare(targetsFromMapping(S.mapping));
      var packed = S.packed, n = packed.length, session = S.session;
      var memo = new Map();
      if (S.out32) {
        var out32 = S.out32;
        for (var j = 0; j < n; j++) {
          var p = packed[j];
          var v = memo.get(p);
          if (v === undefined) {
            var q = session.mapWith(prep, (p >>> 16) & 255, (p >>> 8) & 255, p & 255);
            v = 0xff000000 | ((q & 255) << 16) | (q & 0xff00) | ((q >>> 16) & 255);
            memo.set(p, v);
          }
          out32[j] = v;
        }
      } else {
        var out = S.outData.data;
        for (var j2 = 0, i2 = 0; j2 < n; j2++, i2 += 4) {
          var p2 = packed[j2];
          var q2 = memo.get(p2);
          if (q2 === undefined) {
            q2 = session.mapWith(prep, (p2 >>> 16) & 255, (p2 >>> 8) & 255, p2 & 255);
            memo.set(p2, q2);
          }
          out[i2] = (q2 >>> 16) & 255; out[i2 + 1] = (q2 >>> 8) & 255; out[i2 + 2] = q2 & 255; out[i2 + 3] = 255;
        }
      }
      S.c2d.putImageData(S.outData, 0, 0);
      console.log('[qfp-recolor] ' + (reason || 'repaint') + ': ' + (now() - t0).toFixed(1) +
        'ms (' + memo.size + ' unique colors)');
    }

    function scheduleRepaint(reason) {
      if (S.repaintQueued) return;
      S.repaintQueued = true;
      var run = function () {
        if (!S.repaintQueued) return; // the other scheduler already ran this repaint
        S.repaintQueued = false;
        repaint(reason);
      };
      // rAF coalesces bursts of taps into one repaint per frame — but rAF is
      // throttled/paused entirely in backgrounded/hidden renderers (found
      // during Task-2 browser verification: taps updated state but the canvas
      // never repainted). The timeout fallback guarantees the repaint still
      // lands; the S.repaintQueued flag makes whichever fires first win.
      requestAnimationFrame(run);
      setTimeout(run, 60);
    }

    // ---- family chips (biggest-first from counts, ui_hex fills) -------------
    function familyOrder(palette) {
      var idx = [];
      for (var i = 0; i < palette.K; i++) idx.push(i);
      var counts = palette.counts || [];
      idx.sort(function (a, b) { return (counts[b] || 0) - (counts[a] || 0) || a - b; });
      return idx;
    }

    function buildChips() {
      var box = S.els.chips;
      box.textContent = '';
      S.chipEls = {};
      var counts = S.ctx.palette.counts || [];
      var total = 0;
      for (var i = 0; i < counts.length; i++) total += counts[i];
      S.familyOrder.forEach(function (fid) {
        var btn = el('button', 'qfp-cc-chip');
        btn.type = 'button';
        btn.setAttribute('data-family', String(fid));
        btn.setAttribute('aria-label', 'Color ' + (fid + 1));
        var from = el('span', 'qfp-cc-chip-swatch');
        from.style.background = (S.ctx.palette.ui_hex || [])[fid] || '#ccc';
        var arrow = el('span', 'qfp-cc-chip-arrow', '→');
        var to = el('span', 'qfp-cc-chip-swatch qfp-cc-chip-swatch--to');
        var label = el('span', 'qfp-cc-chip-label', 'Color ' + (fid + 1));
        var pct = el('span', 'qfp-cc-chip-pct', total ? Math.round((counts[fid] || 0) / total * 100) + '%' : '');
        btn.appendChild(from); btn.appendChild(arrow); btn.appendChild(to);
        btn.appendChild(label); btn.appendChild(pct);
        btn.addEventListener('click', function () { selectFamily(fid); });
        box.appendChild(btn);
        S.chipEls[fid] = { btn: btn, to: to, arrow: arrow };
      });
      refreshChips();
    }

    function refreshChips() {
      S.familyOrder.forEach(function (fid) {
        var c = S.chipEls[fid];
        if (!c) return;
        var mapped = Object.prototype.hasOwnProperty.call(S.mapping, String(fid));
        c.btn.classList.toggle('qfp-cc-chip--selected', S.selectedFamily === fid);
        c.btn.classList.toggle('qfp-cc-chip--mapped', mapped);
        if (mapped) {
          var sw = S.swatchById[S.mapping[String(fid)]];
          c.to.style.background = sw ? sw.hex : '#fff';
        }
        c.arrow.style.display = mapped ? '' : 'none';
        c.to.style.display = mapped ? '' : 'none';
      });
    }

    function selectFamily(fid) {
      S.selectedFamily = fid;
      S.els.swatchLabel.textContent = fid === null
        ? 'New color'
        : 'New color for Color ' + (fid + 1);
      refreshChips();
      refreshSwatchGrid();
      // Review finding 1+2: the eyedropper panel mirrors S.selectedFamily —
      // EVERY selection change (chip tap, sample, rebuild default) lands
      // here, so the panel can never show a stale family.
      renderEyedropSelection();
    }

    // ---- swatch picker: honeycomb hex wheel ---------------------------------
    // Office-style honeycomb over the CURATED swatch library (layoutHoneycomb
    // is the pure, tested layout — cells are exactly ctx.swatches, never
    // arbitrary colors, so the approve whitelist / print-chart guarantees are
    // untouched). Rendered as absolutely-positioned <button> cells clipped to
    // hexagons (real buttons = native Tab/Enter/Space + aria-label a11y).
    // Built while the modal body is VISIBLE so clientWidth is measurable.
    var HEX_CLIP_MIN_UNIT = 18.5; // px per unit hex size: sqrt(3)*18.5 ≈ 32px-wide cells (mobile hit-target floor)
    var HEX_CLIP_MAX_UNIT = 26;   // don't balloon sparse libraries into golf balls
    // Vertical slack reserved out of the swatches box before sizing the wheel.
    // Was ~84px (an above-wheel Original chip + a visible name label); both are
    // gone now — Original sits inside the neutral strip and the name label is
    // screen-reader-only (zero layout) — so only the hexwrap's own ~12px
    // padding needs reserving (modal-tighten tweaks 2+3).
    var HONEYCOMB_HEIGHT_RESERVE = 14;

    // A screen-reader-only live region announcing the current selection. Kept
    // for a11y (aria-live) but visually hidden (.qfp-cc-hexname is sr-only in
    // both marker blocks) so it takes ZERO layout space — the honeycomb
    // reclaims that height (modal-tighten tweak 3).
    function appendHexName(box) {
      var name = el('p', 'qfp-cc-hexname');
      name.setAttribute('aria-live', 'polite');
      box.appendChild(name);
      S.hexNameEl = name;
    }

    // The striped "Original" control that maps a family back to its source
    // color. Two placements: a real honeycomb hex at the LEFT end of the
    // neutral (white->black) strip when neutrals exist (Aaron's request —
    // reads [Original][white]…[black]); or, for a library with no neutral
    // strip, the legacy chip above the wheel.
    function makeOriginalChip() {
      var orig = el('button', 'qfp-cc-swatch qfp-cc-swatch--original');
      orig.type = 'button';
      orig.setAttribute('aria-label', 'Original');
      orig.appendChild(el('span', 'qfp-cc-swatch-fill qfp-cc-swatch-fill--original'));
      orig.appendChild(el('span', 'qfp-cc-swatch-name', 'Original'));
      orig.addEventListener('click', function () { onSwatchTap(null); });
      return orig;
    }

    // Shared wheel builder (REVISION 2026-07-19): the Choose Colors tab and
    // the Eyedropper tab must present the SAME honeycomb — one builder, two
    // mounts. Builds the curated wheel (+ the striped Original cell) into
    // `box`, wires every cell to onSwatchTap (the ONE chip-tap pipeline),
    // and returns the swatchEls entries — the caller registers them in
    // S.swatchEls so refreshSwatchGrid keeps every copy's selection in sync.
    function appendHoneycomb(box) {
      var entries = [];

      // Spatial reading order (review FIX 5): cells appended row-by-row so Tab
      // walks the wheel top-left -> bottom-right, ending on the neutral strip.
      var layout = sortCellsReadingOrder(layoutHoneycomb(S.ctx.swatches));

      if (!layout.length) {
        // No wheel at all -> the simple top chip is the only control.
        var only = makeOriginalChip();
        box.appendChild(only);
        entries.push({ id: null, btn: only, activeClass: 'qfp-cc-swatch--active' });
        return entries;
      }

      // Which cells are neutrals (grayscale strip) — Original will sit at that
      // strip's left end. Same chroma test layoutHoneycomb uses.
      var neutralIds = {};
      S.ctx.swatches.forEach(function (sw) {
        if (sw && typeof sw.hex === 'string' && VALID_HEX.test(sw.hex)) {
          var lab = hexToOklab(sw.hex);
          if (Math.hypot(lab[1], lab[2]) < HONEYCOMB_NEUTRAL_CHROMA) neutralIds[sw.swatch_id] = 1;
        }
      });
      var leftNeutral = null;
      layout.forEach(function (c) {
        if (neutralIds[c.swatch_id] && (!leftNeutral || c.x < leftNeutral.x)) leftNeutral = c;
      });

      var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
      layout.forEach(function (c) {
        if (c.x < minX) minX = c.x;
        if (c.x > maxX) maxX = c.x;
        if (c.y < minY) minY = c.y;
        if (c.y > maxY) maxY = c.y;
      });
      // Original occupies the cell one hex LEFT of the leftmost neutral (same
      // row) — fold it into the bounds so it is never clipped.
      var origCx = null, origCy = null;
      if (leftNeutral) {
        origCx = leftNeutral.x - SQRT3; origCy = leftNeutral.y;
        if (origCx < minX) minX = origCx;
      }
      minX -= SQRT3 / 2; maxX += SQRT3 / 2; minY -= 1; maxY += 1;

      var available = box.clientWidth || 300;
      var unit = available / (maxX - minX);
      // Height-aware sizing (modal-fold): at >=768px the Choose Colors
      // swatches box is a flexed column whose height is the space LEFT OVER
      // under the fold — measurable here because it was just emptied. Shrink
      // cells toward the tap-size floor so the wheel fits that budget before
      // falling back to the wrapper's internal scroll. On phones (and in the
      // eyedropper picker, whose box has no fixed height) it measures 0 ->
      // width-only sizing.
      var heightBudget = box.clientHeight ? box.clientHeight - HONEYCOMB_HEIGHT_RESERVE : 0;
      if (heightBudget > 0) {
        var unitH = heightBudget / (maxY - minY);
        if (unitH < unit) unit = unitH;
      }
      if (unit > HEX_CLIP_MAX_UNIT) unit = HEX_CLIP_MAX_UNIT;
      if (unit < HEX_CLIP_MIN_UNIT) unit = HEX_CLIP_MIN_UNIT; // wrapper scrolls instead of shrinking taps below ~32px

      var width = (maxX - minX) * unit, height = (maxY - minY) * unit;
      var wrap = el('div', 'qfp-cc-hexwrap');
      var comb = el('div', 'qfp-cc-honeycomb');
      comb.style.width = width.toFixed(1) + 'px';
      comb.style.height = height.toFixed(1) + 'px';
      comb.setAttribute('role', 'group');
      comb.setAttribute('aria-label', 'Swatch color picker');

      function styleHex(btn, cx, cy) {
        btn.style.left = ((cx - minX) * unit - (SQRT3 / 2) * unit).toFixed(1) + 'px';
        btn.style.top = ((cy - minY) * unit - unit).toFixed(1) + 'px';
        btn.style.width = (SQRT3 * unit).toFixed(1) + 'px';
        btn.style.height = (2 * unit).toFixed(1) + 'px';
      }

      var swById = S.swatchById;
      var origPlaced = false;
      layout.forEach(function (c) {
        // Insert Original immediately before the leftmost neutral: it becomes
        // the leftmost cell of the strip AND the tab stop just before it.
        if (!origPlaced && leftNeutral && c.swatch_id === leftNeutral.swatch_id) {
          var ob = el('button', 'qfp-cc-hex qfp-cc-hex--original');
          ob.type = 'button';
          ob.setAttribute('aria-label', 'Original');
          ob.title = 'Original';
          styleHex(ob, origCx, origCy);
          ob.appendChild(el('span', 'qfp-cc-hex-in'));
          ob.addEventListener('click', function () { onSwatchTap(null); });
          comb.appendChild(ob);
          entries.push({ id: null, btn: ob, activeClass: 'qfp-cc-hex--selected' });
          origPlaced = true;
        }
        var sw = swById[c.swatch_id];
        if (!sw) return;
        var btn = el('button', 'qfp-cc-hex');
        btn.type = 'button';
        btn.setAttribute('data-swatch', sw.swatch_id);
        btn.setAttribute('aria-label', sw.name);
        btn.title = sw.name;
        styleHex(btn, c.x, c.y);
        var fill = el('span', 'qfp-cc-hex-in');
        fill.style.background = sw.hex;
        btn.appendChild(fill);
        btn.addEventListener('click', function () { onSwatchTap(sw.swatch_id); });
        comb.appendChild(btn);
        entries.push({ id: sw.swatch_id, btn: btn, activeClass: 'qfp-cc-hex--selected' });
      });

      wrap.appendChild(comb);

      // Library with no neutral strip -> Original never got placed; fall back
      // to the legacy chip above the wheel (still the first tab stop).
      if (!origPlaced) {
        var chip = makeOriginalChip();
        box.appendChild(chip);
        entries.unshift({ id: null, btn: chip, activeClass: 'qfp-cc-swatch--active' });
      }

      box.appendChild(wrap);
      return entries;
    }

    function buildSwatchGrid() {
      var box = S.els.swatches;
      box.textContent = '';
      S.swatchEls = appendHoneycomb(box);
      appendHexName(box);
      refreshSwatchGrid();
    }

    function refreshSwatchGrid() {
      var current = S.selectedFamily === null ? undefined : S.mapping[String(S.selectedFamily)];
      S.swatchEls.forEach(function (e) {
        var active = (e.id === null && current === undefined) || (e.id !== null && e.id === current);
        e.btn.classList.toggle(e.activeClass, active);
      });
      if (S.hexNameEl) {
        var swatchName = current === undefined
          ? 'Original'
          : (S.swatchById[current] ? S.swatchById[current].name : current);
        S.hexNameEl.textContent = S.selectedFamily === null
          ? ''
          : 'Selected for Color ' + (S.selectedFamily + 1) + ': ' + swatchName;
      }
    }

    function onSwatchTap(swatchId) {
      if (S.selectedFamily === null) return;
      var key = String(S.selectedFamily);
      if (swatchId === null) delete S.mapping[key];
      else S.mapping[key] = swatchId;
      S.approved = null; // any change invalidates a previously minted approval
      saveState();
      // Review finding 5: applying a color clears the family highlight NOW —
      // the 45% white wash sat exactly over the area the customer needs to
      // judge. The "Selected: Color N" label stays (it still names the
      // family further taps retarget).
      if (S.eyedropHilite) S.eyedropHilite.clear();
      refreshChips(); refreshSwatchGrid(); refreshColorwayTiles(); renderEyedropChanges(); updateMeta();
      scheduleRepaint('swatch tap repaint');
    }

    // ---- presets -----------------------------------------------------------
    // The qfp.palette metafield envelope carries preset_mappings as ONE
    // {familyId: swatchId} object (RecolorMath::buildPaletteMetafieldEnvelope);
    // an array of {name, mapping} entries is also accepted (future-proofing).
    // Entries with out-of-range family ids or unknown swatch ids are dropped.
    function normalizePresets(raw) {
      if (!raw || typeof raw !== 'object') return [];
      var list = Array.isArray(raw)
        ? raw.map(function (p, i) { return { name: (p && p.name) || 'Preset ' + (i + 1), mapping: (p && p.mapping) || {} }; })
        : [{ name: 'Suggested', mapping: raw }];
      var out = [];
      list.forEach(function (p) {
        var clean = {};
        Object.keys(p.mapping).forEach(function (fid) {
          if (CANONICAL_FID.test(fid) && +fid < S.ctx.palette.K && S.swatchById[p.mapping[fid]]) {
            clean[fid] = p.mapping[fid];
          }
        });
        if (Object.keys(clean).length) out.push({ name: p.name, mapping: clean });
      });
      return out;
    }

    // Shared thumbnail renderer: draw S.img downscaled into cv (its own
    // width/height), then remap in place through the EXISTING classified
    // session with the given {familyId: swatchId} mapping — the same
    // memoized per-unique-color loop the main repaint uses. A null mapping
    // skips the remap (the downscaled source IS the thumbnail — the
    // Original colorway tile).
    function paintRemappedThumb(cv, mapping) {
      var tw = cv.width, th = cv.height;
      var cc = cv.getContext('2d', { colorSpace: 'srgb', willReadFrequently: true });
      cc.drawImage(S.img, 0, 0, tw, th);
      if (!mapping) return;
      var data = cc.getImageData(0, 0, tw, th);
      var prep = S.session.prepare(targetsFromMapping(mapping));
      var d = data.data, memo = new Map();
      for (var i = 0; i < d.length; i += 4) {
        var pc = (d[i] << 16) | (d[i + 1] << 8) | d[i + 2];
        var qc = memo.get(pc);
        if (qc === undefined) {
          qc = S.session.mapWith(prep, d[i], d[i + 1], d[i + 2]);
          memo.set(pc, qc);
        }
        d[i] = (qc >>> 16) & 255; d[i + 1] = (qc >>> 8) & 255; d[i + 2] = qc & 255;
      }
      cc.putImageData(data, 0, 0);
    }

    function buildPresets() {
      var row = S.els.presetsRow, box = S.els.presets;
      box.textContent = '';
      if (!S.presets.length) { row.hidden = true; return; }
      row.hidden = false;
      var t0 = now();
      var w = S.canvas.width, h = S.canvas.height;
      var scale = Math.min(1, 200 / Math.max(w, h)); // preset thumbnails ~200px (spec §6)
      var tw = Math.max(1, Math.round(w * scale)), th = Math.max(1, Math.round(h * scale));
      S.presets.forEach(function (p) {
        var btn = el('button', 'qfp-cc-preset');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Apply preset: ' + p.name);
        var cv = document.createElement('canvas');
        cv.width = tw; cv.height = th;
        cv.className = 'qfp-cc-preset-thumb';
        paintRemappedThumb(cv, p.mapping);
        btn.appendChild(cv);
        btn.appendChild(el('span', 'qfp-cc-swatch-name', p.name));
        btn.addEventListener('click', function () { applyPreset(p); });
        box.appendChild(btn);
      });
      console.log('[qfp-recolor] preset thumbnails: ' + (now() - t0).toFixed(0) + 'ms (' + S.presets.length + ' presets at ' + tw + 'x' + th + ')');
    }

    function applyPreset(p) {
      S.mapping = {};
      Object.keys(p.mapping).forEach(function (fid) { S.mapping[fid] = p.mapping[fid]; });
      S.approved = null;
      saveState();
      refreshChips(); refreshSwatchGrid(); refreshColorwayTiles(); renderEyedropChanges(); updateMeta();
      scheduleRepaint('preset apply repaint');
    }

    function resetAll() {
      S.mapping = {};
      S.approved = null;
      saveState();
      refreshChips(); refreshSwatchGrid(); refreshColorwayTiles(); renderEyedropChanges(); updateMeta();
      scheduleRepaint('reset repaint');
    }

    // ---- Colorways tab (feature: recolor-tabs §3.2) --------------------------
    // 12 fixed one-color looks (COLORWAYS constant) + an Original tile. Each
    // colorway's hue is snapped ONCE to its nearest curated swatch
    // (nearestSwatch — pure, tested; see its header for why arbitrary hues
    // can't ride in S.mapping), and a tap installs that swatch for every
    // CHROMATIC family via buildColorwayMapping (neutral-keep: snow/gray/
    // black families keep their original color — scenic-panel fix, see the
    // builder's header) — chips, approve, cart, worker all see an ordinary
    // mapping. Tile thumbnails (~140px) render through the SAME
    // snapped mapping, lazily: first Colorways activation starts a chain
    // painting ONE tile per rAF frame (spec: never block the UI thread more
    // than a frame per tile), cached for the rest of the color-UI build.
    var COLORWAY_THUMB_PX = 140;

    function buildColorways() {
      var box = S.els.colorways;
      box.textContent = '';
      S.colorwayEls = [];
      S.colorwayThumbsStarted = false;
      var w = S.canvas.width, h = S.canvas.height;
      var scale = Math.min(1, COLORWAY_THUMB_PX / Math.max(w, h));
      var tw = Math.max(1, Math.round(w * scale)), th = Math.max(1, Math.round(h * scale));

      function makeTile(cwId, name, mapping, extraClass) {
        var btn = el('button', 'qfp-cc-colorway' + (extraClass ? ' ' + extraClass : ''));
        btn.type = 'button';
        btn.setAttribute('aria-label', mapping ? 'Apply colorway: ' + name : 'Back to original colors');
        var cv = document.createElement('canvas');
        cv.width = tw; cv.height = th;
        cv.className = 'qfp-cc-colorway-thumb';
        btn.appendChild(cv);
        btn.appendChild(el('span', 'qfp-cc-swatch-name', name));
        box.appendChild(btn);
        S.colorwayEls.push({ cwId: cwId, btn: btn, canvas: cv, mapping: mapping });
        return btn;
      }

      // Original first: clears the mapping ONLY (Reset/Original semantics
      // are untouched by the eyedropper — REVISION 2026-07-19).
      makeTile(null, 'Original', null, 'qfp-cc-colorway--original')
        .addEventListener('click', function () {
          S.mapping = {};
          S.approved = null;
          saveState();
          refreshChips(); refreshSwatchGrid(); refreshColorwayTiles(); renderEyedropChanges(); updateMeta();
          scheduleRepaint('colorway original repaint');
        });

      COLORWAYS.forEach(function (cw) {
        var snapId = nearestSwatch(S.ctx.swatches, cw.hex);
        if (snapId === null) return; // no valid library entries: no colorway tiles
        var mapping = buildColorwayMapping(S.ctx.palette, snapId);
        makeTile(cw.id, cw.name, mapping).addEventListener('click', function () { applyColorway(cw.name, mapping); });
      });
      refreshColorwayTiles();
    }

    function applyColorway(name, mapping) {
      S.mapping = {};
      Object.keys(mapping).forEach(function (fid) { S.mapping[fid] = mapping[fid]; });
      S.approved = null;
      saveState();
      refreshChips(); refreshSwatchGrid(); refreshColorwayTiles(); renderEyedropChanges(); updateMeta();
      scheduleRepaint('colorway apply repaint (' + name + ')');
    }

    // aria-pressed mirrors whether the CURRENT mapping is exactly this tile's
    // outcome, so hand-edits on the Choose Colors tab un-press a colorway the
    // moment the result diverges (and Original reads pressed when unmapped).
    function mappingsEqual(a, b) {
      var ka = Object.keys(a), kb = Object.keys(b);
      if (ka.length !== kb.length) return false;
      for (var i = 0; i < ka.length; i++) {
        if (a[ka[i]] !== b[ka[i]]) return false;
      }
      return true;
    }

    function refreshColorwayTiles() {
      S.colorwayEls.forEach(function (t) {
        var active = t.mapping === null
          ? Object.keys(S.mapping).length === 0
          : mappingsEqual(S.mapping, t.mapping);
        t.btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    // Lazy rAF-chunked thumbnail chain: kicked off by the FIRST Colorways
    // activation per color-UI build (onTabActivated), one tile per frame.
    // The setTimeout fallback mirrors scheduleRepaint's — rAF is paused in
    // hidden/backgrounded renderers, and the chain must still finish.
    function ensureColorwayThumbs() {
      if (!S.loaded || S.colorwayThumbsStarted) return;
      S.colorwayThumbsStarted = true;
      var queue = S.colorwayEls.slice();
      var t0 = now();
      function schedule(fn) {
        var ran = false;
        var run = function () { if (ran) return; ran = true; fn(); };
        requestAnimationFrame(run);
        setTimeout(run, 60);
      }
      function step() {
        var tile = queue.shift();
        if (!tile) {
          console.log('[qfp-recolor] colorway thumbnails: ' + (now() - t0).toFixed(0) + 'ms (' +
            S.colorwayEls.length + ' tiles, rAF-chunked)');
          return;
        }
        paintRemappedThumb(tile.canvas, tile.mapping);
        schedule(step);
      }
      schedule(step);
    }

    // ---- Eyedropper tab (recolor-tabs REVISION 2026-07-19) -------------------
    // "Tap the color on the panel you want to change." — the preview accepts
    // pointer input in THIS TAB ONLY (crosshair cursor on a canvas overlay).
    // Desktop: click samples immediately. Touch: press-and-drag shows a
    // ~LOUPE_ZOOM× magnifier loupe with a ring on the exact pixel; the
    // sample is taken on release. The tapped pixel classifies to its family
    // against the ORIGINAL conditioned preview pixels (S.packed — never the
    // recolored output, else a recolored area would re-classify wrong);
    // every pixel of that family lights up in a translucent highlight
    // (rAF-chunked build, cached per family), "Selected: Color N" shows the
    // family's original swatch, and the SAME curated honeycomb the Choose
    // Colors chip-tap drives opens for it (appendHoneycomb + selectFamily) —
    // a swatch tap runs onSwatchTap, i.e. the EXACT existing pipeline
    // (S.mapping[family] = target, normal re-render, chips reflect it).
    // Repeatable; Reset/Original behavior untouched; the approve payload is
    // untouched (family mappings only — byte-identical in shape to a
    // Choose Colors order).
    //
    // DOM discipline: the whole tab builds INTO the shell's empty
    // [data-qfp-cc="eyedropper-root"] mount, and its CSS is injected from
    // here — deliberately NOT added to the qfp-modal-css marker block, so
    // the feature ships entirely inside the bundle.
    var EYEDROP_CHUNK_PX = 65536;      // pixels classified per rAF slice of a highlight build
    var EYEDROP_HILITE_ALPHA = 0.45;   // translucent white family highlight (paint-tab precedent)
    var EYEDROP_DASH = [28, 77, 29];   // #1c4d1d dashes on the family edge (visible on any artwork)
    // Loupe sized in CSS px, converted to backing px at draw time so it
    // reads the same physical size on the 1200 and 1600 assets.
    var LOUPE_CSS_DIAMETER = 110;
    var LOUPE_CSS_LIFT = 60;           // lifted above the finger so it isn't covered

    // PointerEvent is the only requirement (the mask upload machinery is
    // gone). Unsupported browsers keep a working modal — the eyedropper
    // panel just shows a friendly note instead of the tap target.
    function eyedropperSupported() {
      return typeof PointerEvent !== 'undefined';
    }

    var EYEDROP_CSS =
      '.qfp-cc-preview-wrap{position:relative}' +
      '.qfp-cc-eyedrop-overlay{position:absolute;left:0;top:0;touch-action:none;cursor:crosshair;border-radius:8px}' +
      '.qfp-cc-eyedrop-selected{display:flex;align-items:center;gap:8px;font-size:13px;font-weight:600;color:#333;margin:8px 0}' +
      '.qfp-cc-eyedrop-swatch{width:22px;height:22px;border-radius:50%;border:1px solid rgba(0,0,0,.15);flex:none}' +
      '.qfp-cc-eyedrop-note{font-size:12.5px;color:#7a6530;background:#fff8e8;border:1px solid #f0dda8;border-radius:8px;padding:8px 12px;margin:8px 0}' +
      '.qfp-cc-eyedrop-picker{margin:8px 0}' +
      /* 65+ design brief: always-visible 1-2-3 instructions — >=14px, high
         contrast, never fine print. */
      '.qfp-cc-eyedrop-steps{margin:0 0 10px;padding:0 0 0 24px;font-size:14.5px;line-height:1.55;color:#222;font-weight:600}' +
      '.qfp-cc-eyedrop-steps li{margin:3px 0}' +
      /* "Your color changes" list — one chip per mapped family */
      '.qfp-cc-eyedrop-changes{margin:10px 0}' +
      '.qfp-cc-eyedrop-changes-lbl{font-size:14px;font-weight:700;color:#333;margin:0 0 6px}' +
      '.qfp-cc-eyedrop-changes-list{display:flex;flex-direction:column;gap:8px}' +
      '.qfp-cc-eyedrop-change{display:flex;align-items:center;gap:8px;padding:5px 5px 5px 12px;border:2px solid #e0d8cf;border-radius:28px;background:#fff;font-size:13.5px;color:#333;min-height:52px;box-sizing:border-box}' +
      '.qfp-cc-eyedrop-change:hover{border-color:#2c5f2d}' +
      /* chip BODY = the "adjust this change" tap target (44px tall, clearly
         separated from the × by the flex gap + the ×'s own 44px circle) */
      '.qfp-cc-eyedrop-change-body{display:flex;align-items:center;gap:8px;flex:1;min-width:0;min-height:44px;border:none;background:none;padding:0;margin:0;font:inherit;color:inherit;cursor:pointer;text-align:left}' +
      '.qfp-cc-eyedrop-change-body:hover .qfp-cc-eyedrop-change-name{text-decoration:underline}' +
      '.qfp-cc-eyedrop-change-swatch{width:22px;height:22px;border-radius:50%;border:1px solid rgba(0,0,0,.15);flex:none}' +
      '.qfp-cc-eyedrop-change-name{font-weight:600;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
      '.qfp-cc-eyedrop-change-arrow{color:#555;font-size:14px;flex:none}' +
      /* remove button: 44px minimum target (aging eyesight/motor precision) */
      '.qfp-cc-eyedrop-change-x{width:44px;height:44px;min-width:44px;border:1.5px solid #ccc;border-radius:50%;background:#fff;color:#555;font-size:22px;line-height:1;cursor:pointer;flex:none;display:flex;align-items:center;justify-content:center;padding:0;margin-left:auto}' +
      '.qfp-cc-eyedrop-change-x:hover{background:#fdf0ef;border-color:#a33a32;color:#a33a32}' +
      /* one-time ~2s attention pulse on the preview when the tab first opens */
      '@keyframes qfpccEyedropCue{0%,100%{box-shadow:0 0 0 0 rgba(44,95,45,0)}50%{box-shadow:0 0 0 7px rgba(44,95,45,.5)}}' +
      '.qfp-cc-eyedrop-cue{animation:qfpccEyedropCue 1s ease-in-out 2}';

    function injectEyedropperCss() {
      if (document.getElementById('qfp-cc-eyedrop-style')) return;
      var style = document.createElement('style');
      style.id = 'qfp-cc-eyedrop-style';
      style.textContent = EYEDROP_CSS;
      document.head.appendChild(style);
    }

    // (Re)build the eyedropper tab into eyedropper-root. DOM refs
    // (S.eyedropEls) rebuild per color-UI build; the sampling CACHES
    // (S.eyedrop — family memo, per-family highlight masks) persist across
    // opens, exactly like S.mapping (spec §3.1: switching/reopening never
    // discards state). The SELECTION is deliberately NOT part of S.eyedrop
    // (review finding 1+2): the panel derives from S.selectedFamily via
    // renderEyedropSelection. Canvas dims are final here (loadAndClassify
    // ran once).
    function buildEyedropperUi() {
      var root = S.els.eyedropperRoot;
      root.textContent = '';
      if (S.eyedropEls && S.eyedropEls.overlay && S.eyedropEls.overlay.parentNode) {
        S.eyedropEls.overlay.parentNode.removeChild(S.eyedropEls.overlay);
      }
      S.eyedropEls = null;
      injectEyedropperCss();
      if (!eyedropperSupported()) {
        root.appendChild(el('p', 'qfp-cc-eyedrop-note',
          'Tap to Change needs a newer browser — please use Choose Colors or Colorways instead.'));
        return;
      }
      if (!S.eyedrop) {
        S.eyedrop = {
          familyMemo: new Map(), // packed color -> top family (classification is mapping-independent)
          maskCache: {},         // familyId -> Uint8Array(w*h) family-membership mask
          tracking: false,       // touch press-and-drag loupe active
          hovering: false,       // desktop mouse hover loupe active (eyedropHoverShowsLoupe)
          pointerId: null,       // captured pointer, so a tab-switch abort can release it
          lastX: 0, lastY: 0,    // latest pointer position in backing px (loupe ring)
          buildToken: 0,         // invalidates an in-flight highlight build when a new sample lands
        };
      }

      // Canvas overlay on the preview: the tab's pointer input (crosshair),
      // the family highlight, and the touch loupe all live on it. Same
      // geometry-glue approach the fold CSS forces (syncEyedropperOverlay).
      var overlay = document.createElement('canvas');
      overlay.width = S.canvas.width;
      overlay.height = S.canvas.height;
      overlay.className = 'qfp-cc-eyedrop-overlay';
      overlay.setAttribute('aria-label', 'Tap to Change — tap the picture to pick the color to change');
      S.canvas.parentNode.appendChild(overlay);
      overlay.addEventListener('pointerdown', onEyedropPointerDown);
      overlay.addEventListener('pointermove', onEyedropPointerMove);
      overlay.addEventListener('pointerup', onEyedropPointerUp);
      overlay.addEventListener('pointercancel', onEyedropPointerCancel);
      // Desktop hover magnifier cleanup: leaving the canvas hides the loupe.
      // Bound once per overlay build; the overlay's removal (top of this
      // function / next rebuild) is the teardown, so nothing leaks.
      overlay.addEventListener('pointerleave', onEyedropPointerLeave);

      // ALWAYS-VISIBLE 1-2-3 instructions (65+ design brief): plain words,
      // big type — the panel must teach multi-color use at a glance.
      var steps = el('ol', 'qfp-cc-eyedrop-steps');
      for (var si = 0; si < EYEDROP_INSTRUCTIONS.length; si++) {
        steps.appendChild(el('li', null, EYEDROP_INSTRUCTIONS[si]));
      }

      // "Selected:" line with the family's ORIGINAL swatch (ui_hex), hidden
      // until the first sample. When the family is already mapped the line
      // grows a second square + name — "Selected: Red — currently Deep
      // Blue" (Task 4: re-changing must read as adjusting, not adding).
      var selected = el('p', 'qfp-cc-eyedrop-selected');
      selected.hidden = true;
      var selSwatch = el('span', 'qfp-cc-eyedrop-swatch');
      var selLabel = el('span');
      var selCurSwatch = el('span', 'qfp-cc-eyedrop-swatch');
      selCurSwatch.hidden = true;
      var selCurName = el('span');
      selected.appendChild(selSwatch);
      selected.appendChild(selLabel);
      selected.appendChild(selCurSwatch);
      selected.appendChild(selCurName);

      // The honeycomb mount (hidden until the first sample; built lazily by
      // ensureEyedropPicker because it can only measure while this panel is
      // the visible one).
      var picker = el('div', 'qfp-cc-eyedrop-picker');
      picker.hidden = true;

      // "Your color changes" list — one chip per CURRENTLY MAPPED family
      // (derived from S.mapping, so changes made in ANY tab appear), each
      // with a large × that reruns the Choose Colors un-map path.
      var changes = el('div', 'qfp-cc-eyedrop-changes');
      changes.hidden = true;
      changes.appendChild(el('p', 'qfp-cc-eyedrop-changes-lbl', 'Your color changes'));
      var changesList = el('div', 'qfp-cc-eyedrop-changes-list');
      changes.appendChild(changesList);

      // Panel order (Aaron: "I didn't even see it at the bottom"):
      // instructions → selected line → Your color changes → honeycomb
      // picker. The changes list sits directly under the selected line so
      // it is always seen before the (tall) picker; on narrow phones the
      // picker may fall below the fold — accepted trade-off, the list's
      // visibility is the priority.
      root.appendChild(steps);
      root.appendChild(selected);
      root.appendChild(changes);
      root.appendChild(picker);

      S.eyedropEls = {
        overlay: overlay,
        octx: overlay.getContext('2d'),
        hiliteCanvas: null,    // offscreen render of the family highlight (drawImage is cheap per frame)
        hiliteData: null,
        hiliteFor: null,       // family the offscreen render currently holds
        selected: selected, selSwatch: selSwatch, selLabel: selLabel,
        selCurSwatch: selCurSwatch, selCurName: selCurName,
        picker: picker,
        pickerBuilt: false,
        changes: changes, changesList: changesList,
      };
      // No lastFamily restore here (review finding 2): the panel DERIVES
      // from S.selectedFamily — showColorStep's selectFamily(...) call right
      // after this build (and every later selection change) renders it via
      // renderEyedropSelection, so a reopen can never show a stale family.
      renderEyedropSelection();
      renderEyedropChanges();
      syncEyedropperOverlay();
    }

    // Keep the overlay's CSS box glued to the preview canvas's drawn rect
    // (the canvas is centered/height-capped by the fold CSS, so its offset
    // inside .qfp-cc-preview-wrap — position:relative via injected CSS —
    // changes with viewport size). Hidden on every tab but Eyedropper — the
    // DOM half of the tab gate (eyedropperInputAllowed is the logic half).
    function syncEyedropperOverlay() {
      if (!S.eyedropEls) return;
      var o = S.eyedropEls.overlay, cv = S.canvas;
      o.hidden = !eyedropperInputAllowed(S.activeTab);
      o.style.left = cv.offsetLeft + 'px';
      o.style.top = cv.offsetTop + 'px';
      o.style.width = cv.clientWidth + 'px';
      o.style.height = cv.clientHeight + 'px';
    }

    function eyedropCoords(e) {
      var o = S.eyedropEls.overlay;
      var rect = o.getBoundingClientRect();
      return {
        x: (e.clientX - rect.left) * (o.width / (rect.width || 1)),
        y: (e.clientY - rect.top) * (o.height / (rect.height || 1)),
      };
    }

    function onEyedropPointerDown(e) {
      if (!eyedropperInputAllowed(S.activeTab) || !S.eyedropEls) return;
      e.preventDefault();
      var pt = eyedropCoords(e);
      S.eyedrop.lastX = pt.x; S.eyedrop.lastY = pt.y;
      if (e.pointerType === 'touch') {
        // Touch: press-and-drag loupe; the sample lands on release.
        S.eyedrop.tracking = true;
        S.eyedrop.pointerId = e.pointerId;
        try { S.eyedropEls.overlay.setPointerCapture(e.pointerId); } catch (err) { /* capture is best-effort */ }
        renderEyedropOverlay();
      } else {
        // Desktop click samples immediately. The hover loupe hides for the
        // sample (it would sit exactly over the area being judged); the next
        // buttonless hover move re-shows it.
        S.eyedrop.hovering = false;
        sampleEyedropAt(pt.x, pt.y);
      }
    }

    function onEyedropPointerMove(e) {
      if (!S.eyedrop) return;
      if (S.eyedrop.tracking) {
        e.preventDefault();
        var pt = eyedropCoords(e);
        S.eyedrop.lastX = pt.x; S.eyedrop.lastY = pt.y;
        renderEyedropOverlay();
        return;
      }
      // Desktop hover magnifier: the SAME loupe the touch press-drag shows,
      // following the mouse, ring on the exact pixel a click would sample.
      // eyedropHoverShowsLoupe (pure, tested) gates it to a buttonless MOUSE
      // in this tab; every state flip re-renders on the event itself — no
      // rAF loop to leak.
      if (!S.eyedropEls) return;
      if (eyedropHoverShowsLoupe(S.activeTab, e.pointerType, e.buttons)) {
        var hp = eyedropCoords(e);
        S.eyedrop.lastX = hp.x; S.eyedrop.lastY = hp.y;
        S.eyedrop.hovering = true;
        renderEyedropOverlay();
      } else if (S.eyedrop.hovering) {
        S.eyedrop.hovering = false;
        renderEyedropOverlay();
      }
    }

    // Mouse left the canvas: the hover loupe goes with it.
    function onEyedropPointerLeave() {
      if (!S.eyedrop || !S.eyedrop.hovering) return;
      S.eyedrop.hovering = false;
      renderEyedropOverlay();
    }

    function onEyedropPointerUp(e) {
      if (!S.eyedrop || !S.eyedrop.tracking) return;
      S.eyedrop.tracking = false;
      S.eyedrop.pointerId = null;
      try { S.eyedropEls.overlay.releasePointerCapture(e.pointerId); } catch (err) { /* no-op */ }
      // Release decision (review findings 3+4): sample ONLY when the
      // eyedropper tab is still active AND the release point is on-canvas —
      // a slide-off-to-abort or a mid-drag tab switch cancels (no sample,
      // loupe hidden by the overlay re-render below).
      var pt = eyedropCoords(e);
      S.eyedrop.lastX = pt.x; S.eyedrop.lastY = pt.y;
      var o = S.eyedropEls.overlay;
      if (!eyedropReleaseSamples(S.activeTab, pt.x, pt.y, o.width, o.height)) {
        renderEyedropOverlay();
        return;
      }
      sampleEyedropAt(pt.x, pt.y); // ring position = sampled pixel
    }

    function onEyedropPointerCancel(e) {
      if (!S.eyedrop || !S.eyedrop.tracking) return;
      S.eyedrop.tracking = false; // canceled press: no sample taken
      S.eyedrop.pointerId = null;
      try { S.eyedropEls.overlay.releasePointerCapture(e.pointerId); } catch (err) { /* no-op */ }
      renderEyedropOverlay();
    }

    // Abort an in-flight touch press without sampling (review finding 4's
    // second half): tab switches and modal closes land here so a captured
    // pointer/tracking loupe never survives into a tab where eyedropper
    // input is gated off — the eventual pointerup then no-ops on tracking.
    function cancelEyedropTracking() {
      if (!S.eyedrop || (!S.eyedrop.tracking && !S.eyedrop.hovering)) return;
      S.eyedrop.tracking = false;
      S.eyedrop.hovering = false; // tab deactivation/close also drops the hover loupe
      if (S.eyedropEls && S.eyedrop.pointerId !== null) {
        try { S.eyedropEls.overlay.releasePointerCapture(S.eyedrop.pointerId); } catch (err) { /* already released */ }
      }
      S.eyedrop.pointerId = null;
      renderEyedropOverlay(); // hides the loupe
    }

    // One sample: pointer coords -> ORIGINAL pixel -> family -> selection.
    function sampleEyedropAt(x, y) {
      var w = S.canvas.width, h = S.canvas.height;
      var px = clampPixel(x, y, w, h);
      // S.packed holds the ORIGINAL conditioned preview pixels — the frozen
      // classification input (never the recolored output on the canvas).
      var p = S.packed[px.y * w + px.x];
      var fid = eyedropperFamily(S.session.pal, (p >>> 16) & 255, (p >>> 8) & 255, p & 255);
      focusEyedropFamily(fid);
    }

    // The shared "this family is now the one being changed" path — a sample
    // AND a changes-list chip tap (Task 4) both land here, so re-selecting a
    // prior change behaves exactly like re-sampling that area:
    //  - selectFamily: the chip-tap entry point — selects the family
    //    everywhere (chips, the Choose Colors honeycomb, the eyedropper
    //    panel via renderEyedropSelection, the sr-only label) — review
    //    finding 1+2: S.selectedFamily is the ONE source of truth;
    //  - orientation flash (review finding 5): the family highlight shows
    //    for ~EYEDROP_HILITE_MS or until a color is applied.
    function focusEyedropFamily(fid) {
      selectFamily(fid);
      S.eyedropHilite.show();
      buildFamilyHighlight(fid);
    }

    // A chip BODY tap (Task 4): adjust that prior change — the exact
    // re-sample path plus a gentle scroll so the honeycomb (already marked
    // at the family's CURRENT swatch by refreshSwatchGrid) is in view for
    // the swap. The × beside it stays the remove path, untouched.
    function editEyedropChange(fid) {
      focusEyedropFamily(fid);
      var picker = S.eyedropEls && S.eyedropEls.picker;
      if (picker && !picker.hidden && picker.scrollIntoView) {
        try { picker.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
        catch (e) { picker.scrollIntoView(); }
      }
    }

    // Derive the eyedropper panel's "Selected: Color N" line (label +
    // original-family swatch + honeycomb) from S.selectedFamily — the pure
    // eyedropSelectionView is the tested derivation (review finding 1+2).
    // Called from selectFamily on EVERY selection change and on eyedropper
    // tab activation; safe no-op before the tab DOM exists.
    function renderEyedropSelection() {
      if (!S.eyedropEls) return;
      var view = eyedropSelectionView(S.selectedFamily, S.ctx.palette.ui_hex, S.mapping, S.ctx.swatches);
      S.eyedropEls.selected.hidden = !view.visible;
      if (view.visible) {
        S.eyedropEls.selSwatch.style.background = view.swatchHex;
        if (view.mapped) {
          // "[sq] Selected: Red — currently [sq] Deep Blue" — the DOM
          // composes view.label around the two squares (Task 4).
          S.eyedropEls.selLabel.textContent = 'Selected: ' + view.originalName + ' — currently';
          S.eyedropEls.selCurSwatch.style.background = view.currentHex;
          S.eyedropEls.selCurSwatch.hidden = false;
          S.eyedropEls.selCurName.textContent = view.currentName;
        } else {
          S.eyedropEls.selLabel.textContent = view.label;
          S.eyedropEls.selCurSwatch.hidden = true;
          S.eyedropEls.selCurName.textContent = '';
        }
      }
      ensureEyedropPicker();
      renderEyedropOverlay(); // the highlight (when visible) tracks the same family
    }

    // Deferred honeycomb build: appendHoneycomb sizes itself from the mount's
    // clientWidth, so it must wait for the FIRST moment the eyedropper panel
    // is both selected-in AND visible (first sample, or tab activation when a
    // selection already exists). Entries register in S.swatchEls so
    // refreshSwatchGrid mirrors the Choose Colors selection state here too.
    function ensureEyedropPicker() {
      if (!S.eyedropEls || S.eyedropEls.pickerBuilt) return;
      if (S.selectedFamily === null) return; // derives from the one source of truth (finding 1+2)
      if (!eyedropperInputAllowed(S.activeTab)) return; // panel hidden: not measurable yet
      var box = S.eyedropEls.picker;
      box.hidden = false;
      box.textContent = '';
      appendHoneycomb(box).forEach(function (entry) { S.swatchEls.push(entry); });
      S.eyedropEls.pickerBuilt = true;
      refreshSwatchGrid();
    }

    // The "Your color changes" list — a pure derivation of S.mapping
    // (eyedropChangesView, tested), re-rendered by the SAME refresh chain
    // refreshColorwayTiles rides (every mapping mutation site calls it).
    // Chips read in plain words for the 65+ demographic: original swatch
    // square + name → new swatch square + curated name, with a large
    // accessible × per chip.
    function renderEyedropChanges() {
      if (!S.eyedropEls) return;
      // The selected line derives from the mapping too ("Selected: Red —
      // currently Deep Blue"), so every mapping change re-renders it here
      // alongside the list (Task 4).
      renderEyedropSelection();
      var view = eyedropChangesView(S.mapping, S.ctx.palette.ui_hex, S.ctx.swatches);
      S.eyedropEls.changes.hidden = !view.visible;
      var list = S.eyedropEls.changesList;
      list.textContent = '';
      view.entries.forEach(function (en) {
        var chip = el('div', 'qfp-cc-eyedrop-change');
        // Chip BODY is a real button (Task 4): tapping it re-selects the
        // family to adjust that change — distinct 44px target from the ×.
        var body = el('button', 'qfp-cc-eyedrop-change-body');
        body.type = 'button';
        body.setAttribute('aria-label', en.editLabel);
        body.title = en.editLabel;
        body.addEventListener('click', function () { editEyedropChange(en.family); });
        var from = el('span', 'qfp-cc-eyedrop-change-swatch');
        from.style.background = en.fromHex;
        var to = el('span', 'qfp-cc-eyedrop-change-swatch');
        to.style.background = en.toHex;
        body.appendChild(from);
        body.appendChild(el('span', 'qfp-cc-eyedrop-change-name', en.fromName));
        body.appendChild(el('span', 'qfp-cc-eyedrop-change-arrow', '→'));
        body.appendChild(to);
        body.appendChild(el('span', 'qfp-cc-eyedrop-change-name', en.toName));
        var x = el('button', 'qfp-cc-eyedrop-change-x', '×');
        x.type = 'button';
        x.setAttribute('aria-label', en.removeLabel);
        x.title = en.removeLabel;
        x.addEventListener('click', function () { removeEyedropChange(en.family); });
        chip.appendChild(body);
        chip.appendChild(x);
        list.appendChild(chip);
      });
    }

    // A chip's × — the EXACT Choose Colors un-map path, never a second one:
    // select the family (the same chip-tap entry point every selector uses),
    // then the Original tap (onSwatchTap(null)) deletes that family's
    // mapping and runs the normal refresh + repaint chain, so ONLY that
    // family's pixels revert in the preview.
    function removeEyedropChange(fid) {
      selectFamily(fid);
      onSwatchTap(null);
    }

    // rAF-chunked highlight build (REVISION: "build in rAF chunks, cached per
    // family"): classify EYEDROP_CHUNK_PX original pixels per frame through
    // the shared memo, then render. The token check abandons a build the
    // moment a newer sample supersedes it; the same rAF+timeout dual
    // fallback as scheduleRepaint keeps hidden renderers finishing.
    function buildFamilyHighlight(fid) {
      if (S.eyedrop.maskCache[fid]) { renderEyedropOverlay(); return; }
      var w = S.canvas.width, h = S.canvas.height;
      var mask = new Uint8Array(w * h);
      var token = ++S.eyedrop.buildToken;
      var pos = 0, total = w * h;
      var t0 = now();
      function schedule(fn) {
        var ran = false;
        var run = function () { if (ran) return; ran = true; fn(); };
        requestAnimationFrame(run);
        setTimeout(run, 60);
      }
      function step() {
        if (token !== S.eyedrop.buildToken) return; // superseded by a newer sample
        var end = Math.min(total, pos + EYEDROP_CHUNK_PX);
        familyMaskChunk(S.packed, pos, end, S.session.pal, fid, mask, S.eyedrop.familyMemo);
        pos = end;
        if (pos < total) { schedule(step); return; }
        S.eyedrop.maskCache[fid] = mask;
        console.log('[qfp-recolor] family ' + fid + ' highlight: ' + (now() - t0).toFixed(0) + 'ms (rAF-chunked)');
        renderEyedropOverlay();
      }
      schedule(step);
    }

    // Offscreen render of the family highlight: translucent white over every
    // family pixel with dark dashed pixels on the edge (clearly visible on
    // light AND dark artwork — paint-overlay precedent). Rendered ONCE per
    // family switch; per-frame loupe redraws then just drawImage it.
    function renderEyedropHilite(fid, mask) {
      var w = S.canvas.width, h = S.canvas.height;
      var els = S.eyedropEls;
      if (!els.hiliteCanvas) {
        els.hiliteCanvas = document.createElement('canvas');
        els.hiliteCanvas.width = w;
        els.hiliteCanvas.height = h;
        els.hictx = els.hiliteCanvas.getContext('2d');
      }
      var img = els.hiliteData || (els.hiliteData = els.hictx.createImageData(w, h));
      var d = img.data;
      var A = Math.round(255 * EYEDROP_HILITE_ALPHA);
      for (var j = 0, i = 0; j < mask.length; j++, i += 4) {
        if (!mask[j]) { d[i + 3] = 0; continue; }
        var x = j % w, y = (j - x) / w;
        var edge = (x === 0 || !mask[j - 1]) || (x === w - 1 || !mask[j + 1]) ||
                   (y === 0 || !mask[j - w]) || (y === h - 1 || !mask[j + w]);
        if (edge && ((x + y) & 7) < 5) {
          d[i] = EYEDROP_DASH[0]; d[i + 1] = EYEDROP_DASH[1]; d[i + 2] = EYEDROP_DASH[2]; d[i + 3] = 255;
        } else {
          d[i] = 255; d[i + 1] = 255; d[i + 2] = 255; d[i + 3] = A;
        }
      }
      els.hictx.putImageData(img, 0, 0);
      els.hiliteFor = fid;
    }

    function renderEyedropOverlay() {
      if (!S.eyedropEls) return;
      var o = S.eyedropEls.overlay, ctx = S.eyedropEls.octx;
      ctx.clearRect(0, 0, o.width, o.height);
      // The highlight family IS S.selectedFamily (review finding 1+2) and it
      // only paints while the lifetime state machine says so (finding 5 —
      // ~1.5s after a sample/tab entry, gone the moment a color is applied).
      var fid = S.selectedFamily;
      var mask = (fid === null || !S.eyedrop) ? null : S.eyedrop.maskCache[fid];
      if (mask && S.eyedropHilite.visible()) {
        if (S.eyedropEls.hiliteFor !== fid) renderEyedropHilite(fid, mask);
        ctx.drawImage(S.eyedropEls.hiliteCanvas, 0, 0);
      }
      // The loupe draws for a touch press-drag OR a desktop mouse hover —
      // the exact same rendering either way (drawEyedropLoupe).
      if (S.eyedrop && (S.eyedrop.tracking || S.eyedrop.hovering)) drawEyedropLoupe(ctx, o.width, o.height);
    }

    // The touch loupe: a clipped ~LOUPE_ZOOM× view of the CURRENT preview
    // (recolors included) under the finger, ring marking the exact pixel
    // that samples on release. Pure placement/zoom math is loupeCenter/
    // loupeTransform (tested); this only draws.
    function drawEyedropLoupe(ctx, w, h) {
      var rect = S.eyedropEls.overlay.getBoundingClientRect();
      var scale = rect.width ? w / rect.width : 1; // CSS px -> backing px
      var d = LOUPE_CSS_DIAMETER * scale;
      var px = S.eyedrop.lastX, py = S.eyedrop.lastY;
      var c = loupeCenter(px, py, w, h, d, LOUPE_CSS_LIFT * scale);
      var t = loupeTransform(px, py, c.x, c.y, LOUPE_ZOOM);
      var r = d / 2;
      ctx.save();
      ctx.beginPath();
      ctx.arc(c.x, c.y, r, 0, 2 * Math.PI);
      ctx.clip();
      ctx.fillStyle = '#fff'; // backing for edge samples where the zoomed view runs off-canvas
      ctx.fill();
      ctx.setTransform(LOUPE_ZOOM, 0, 0, LOUPE_ZOOM, t.dx, t.dy);
      ctx.drawImage(S.canvas, 0, 0);
      ctx.restore();
      // rim + the exact-pixel ring (white over dark outline reads on any art)
      ctx.beginPath();
      ctx.arc(c.x, c.y, r, 0, 2 * Math.PI);
      ctx.lineWidth = Math.max(2, 3 * scale);
      ctx.strokeStyle = '#2c5f2d';
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(c.x, c.y, Math.max(4.5, 6.5 * scale), 0, 2 * Math.PI);
      ctx.lineWidth = Math.max(1, 1.5 * scale);
      ctx.strokeStyle = 'rgba(0,0,0,.55)';
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(c.x, c.y, Math.max(3, 5 * scale), 0, 2 * Math.PI);
      ctx.lineWidth = Math.max(1, 1.2 * scale);
      ctx.strokeStyle = '#fff';
      ctx.stroke();
    }

    // ---- price footer / summary / ΔE warnings -------------------------------
    function updateMeta() {
      // The CHOSEN size's price drives the +25% footer (ctx.product.priceCents
      // is only the skip-path fallback via currentPriceCents).
      var priceText = priceFooter(currentPriceCents());
      S.els.price.textContent = priceText;
      S.els.approvalPrice.textContent = priceText;
      // Change-summary line ("N colors changed…" / "No colors changed") is
      // intentionally NOT shown to the customer (Aaron 2026-07-14): the live
      // preview speaks for itself. summary() REMAINS the 'Custom Colors'
      // cart-property value (frozen contract — the order + RIP read it), so
      // only the on-screen display is suppressed. The element is kept in the
      // shell (empty + hidden) so no marker-block/shell edit is needed.
      S.els.summary.textContent = '';
      S.els.summary.hidden = true;
      S.els.continue.disabled = Object.keys(S.mapping).length === 0;

      // ΔE "nearly identical" warnings are intentionally NOT surfaced in the UI
      // (Aaron 2026-07-14): the customer sees the live preview and chooses
      // freely. deltaEWarnings() stays exported + unit-tested so the warning can
      // be re-enabled later without rebuilding the logic; the warnings box is
      // kept in the shell (empty + hidden) so no marker-block/shell edit is
      // needed here.
      S.els.warnings.textContent = '';
      S.els.warnings.hidden = true;
    }

    // ---- approval screen ----------------------------------------------------
    function showApproval() {
      hide(S.els.body);
      show(S.els.approval);
      setStatus(S.els.approvalStatus, '', false);
      var ac = S.els.approvalCanvas;
      ac.width = S.canvas.width;
      ac.height = S.canvas.height;
      ac.getContext('2d', { colorSpace: 'srgb' }).drawImage(S.canvas, 0, 0);
      S.els.approvalCheck.checked = false;
      refreshApproveButton();
    }

    function refreshApproveButton() {
      var b = S.els.approve;
      if (S.approved) {
        b.textContent = 'Retry add to cart';
        b.disabled = false;
      } else {
        b.textContent = 'Approve & Add to Cart';
        b.disabled = !S.els.approvalCheck.checked;
      }
    }

    // JPEG of the approved preview: <=600px longest side, quality 0.8 (frozen
    // contract). Quality backs off defensively if the encode somehow exceeds
    // the APA's 300KB hard cap (essentially unreachable at 600px/0.8).
    function approvalBlob() {
      var w = S.canvas.width, h = S.canvas.height;
      var scale = Math.min(1, APPROVE_MAX_PREVIEW_PX / Math.max(w, h));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(w * scale));
      c.height = Math.max(1, Math.round(h * scale));
      c.getContext('2d', { colorSpace: 'srgb' }).drawImage(S.canvas, 0, 0, c.width, c.height);
      return new Promise(function (resolve, reject) {
        function attempt(q) {
          c.toBlob(function (blob) {
            if (!blob) return reject(new Error('canvas.toBlob returned null'));
            if (blob.size <= APPROVE_MAX_PREVIEW_BYTES || q <= 0.5) return resolve(blob);
            attempt(q - 0.15);
          }, 'image/jpeg', q);
        }
        attempt(APPROVE_JPEG_QUALITY);
      });
    }

    function onApproveClick() {
      if (S.approved) { addToCart(); return; } // approve succeeded earlier: retry ONLY the cart add
      if (!S.els.approvalCheck.checked) return;
      S.els.approve.disabled = true;
      setStatus(S.els.approvalStatus, 'Uploading your approved preview…', false);

      // Snapshot of the mapping the token is minted for (review FIX 1):
      // captured at the same moment the POST payload serializes S.mapping.
      var mintedFor = null;

      approvalBlob().then(function (blob) {
        var meta = buildApprovePayloadMeta(
          S.ctx.product.id, S.ctx.palette.palette_hash, RecolorCore.CORE_VERSION, S.mapping);
        mintedFor = serializeMappingCanonical(S.mapping);
        var fd = new FormData();
        fd.append('product_id', meta.product_id);
        fd.append('palette_hash', meta.palette_hash);
        fd.append('core_version', meta.core_version);
        fd.append('mapping', meta.mapping);
        fd.append('preview_jpeg', blob, 'preview.jpg');
        return fetch(S.ctx.apaBase + '/api/recolor/approve', { method: 'POST', body: fd });
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          return { status: res.status, body: body || {} };
        });
      }).then(function (r) {
        if (r.status === 200 && r.body.token) {
          // In-flight race guard (review FIX 1): Back/Change-size/swatch
          // edits stay clickable during the POST. If the customer navigated
          // away or the live mapping no longer matches what the token was
          // minted for, DISCARD the mint — auto-adding would create a cart
          // line whose token-scoped RIP render differs from its recorded
          // _recolor_mapping. The customer simply taps Approve again.
          var approvalActive = S.open && !S.els.approval.hidden;
          if (!approveResultStillValid(mintedFor, S.mapping, approvalActive)) {
            console.warn('[qfp-recolor] approve resolved after the mapping/screen changed — mint discarded');
            S.approved = null;
            setStatus(S.els.approvalStatus, '', false);
            refreshApproveButton();
            return;
          }
          S.approved = { token: r.body.token, previewUrl: r.body.preview_url || '' };
          setStatus(S.els.approvalStatus, 'Approved — adding to cart…', false);
          return addToCart();
        }
        if (r.status === 409 && r.body.error === 'palette_updated') {
          clearSavedState();
          setStatus(S.els.approvalStatus,
            "This product's colors were just updated — please refresh the page and customize again.", true);
        } else if (r.status === 409 && r.body.error === 'core_version') {
          console.error('[qfp-recolor] core_version rejected by APA — hiding the customize feature');
          disableFeature();
          return;
        } else if (r.status === 429) {
          setStatus(S.els.approvalStatus,
            'Lots of customizing happening right now — please try again in a minute.', true);
        } else {
          setStatus(S.els.approvalStatus,
            'Customization is briefly unavailable — please try again shortly.', true);
        }
        refreshApproveButton();
      }).catch(function (err) {
        console.error('[qfp-recolor] approve failed:', err);
        setStatus(S.els.approvalStatus,
          'Customization is briefly unavailable — please try again shortly.', true);
        refreshApproveButton();
      });
    }

    // ---- cart add (frozen properties; edit mode replaces the line) ----------
    function addToCart() {
      // 'Custom Colors' cart property is a simple "Yes" (Aaron 2026-07-14) — the
      // full per-family detail lives in '_recolor_mapping'; the RIP caption reads
      // "Custom Colors: Yes". Kept as one of the exact 4 frozen keys.
      var props = buildCartProperties(
        'Yes', S.approved.token, S.mapping, S.approved.previewUrl);
      // The modal's size choice wins for this line (the page's own variant
      // picker is deliberately NOT synced); ctx.product.variantId is only the
      // skip-path fallback.
      var payload = {
        id: S.chosenVariant ? S.chosenVariant.id : S.ctx.product.variantId,
        quantity: 1,
        properties: props,
      };
      window.qfpRecolorLastPayload = payload; // test hook (MV mvcpLastPayload pattern)
      S.els.approve.disabled = true;
      setStatus(S.els.approvalStatus, 'Adding to cart…', false);

      var pre = Promise.resolve();
      if (S.editLine) {
        var line = S.editLine;
        pre = fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 }),
        }).then(function (res) {
          if (!res.ok) throw new Error('cart change failed: ' + res.status);
          S.editLine = null; // old line removed — never try twice
        });
      }

      return pre.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      }).then(function (res) {
        if (!res.ok) throw new Error('cart add failed: ' + res.status);
        return res.json().catch(function () { return {}; });
      }).then(function () {
        clearSavedState();
        onAddedToCart();
      }).catch(function (err) {
        // Approval token is retained — the retry re-runs ONLY the cart add.
        console.error('[qfp-recolor] cart add failed (approval retained):', err);
        setStatus(S.els.approvalStatus,
          'Your colors are approved, but adding to cart failed — tap "Retry add to cart".', true);
        refreshApproveButton();
      });
    }

    function onAddedToCart() {
      S.mapping = {};
      S.approved = null;
      saveState();

      // The Refresh theme declares its pub/sub as top-level script bindings
      // (pubsub.js: `function publish`, constants.js: `const PUB_SUB_EVENTS`).
      // A top-level `const` is NOT a window property, so the old
      // `window.PUB_SUB_EVENTS` check was always undefined and every customer
      // landed on the in-modal "View cart / Checkout" fallback instead of the
      // sliding cart drawer (Aaron 2026-10-22). Resolve both as bare globals,
      // exactly like custom-panel-size.liquid does.
      var pubsubPublish = typeof publish === 'function' ? publish : null;
      var pubsubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && pubsubPublish && pubsubEvents) {
        // Refresh theme: clone of custom-panel-size.liquid's post-add refresh —
        // pub/sub drawer re-render + cart-icon-bubble section swap + drawer open.
        closeModal(false);
        pubsubPublish(pubsubEvents.cartUpdate, { source: 'qfp-custom-colors' });
        if (window.routes && window.routes.cart_url) {
          fetch(window.routes.cart_url + '?section_id=cart-icon-bubble')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              var newBubble = parsed.querySelector('.shopify-section');
              var oldBubble = document.getElementById('shopify-section-cart-icon-bubble');
              if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
            });
        }
        setTimeout(function () {
          cartDrawer.classList.remove('is-empty');
          var items = document.querySelector('cart-drawer-items');
          if (items) items.classList.remove('is-empty');
          var emptyDiv = document.querySelector('.drawer__inner-empty');
          if (emptyDiv) emptyDiv.style.display = 'none';
          var drawerInner = document.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.style.transform = 'none';
          var checkoutBtn = document.getElementById('CartDrawer-Checkout');
          if (checkoutBtn) checkoutBtn.disabled = false;
          fixCartDrawer();
          cartDrawer.open();
        }, 800);
      } else {
        // No Refresh drawer (harness / unexpected theme): in-modal success panel.
        hide(S.els.approval); hide(S.els.body);
        S.els.successSummary.textContent = (S.ctx.product.title || '');
        show(S.els.success);
      }
    }

    // Cart-drawer thumbnail fixer — clone of the custom-panel-size.liquid
    // pattern: read the just-added line's properties back from /cart.js and
    // swap the drawer line image to the approved recolor preview. Underscore
    // properties are already hidden by the Refresh theme's own template.
    function fixCartDrawer() {
      setTimeout(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var items = document.querySelectorAll('#CartDrawer-Form .cart-item');
          items.forEach(function (item, idx) {
            var ci = cart.items && cart.items[idx];
            if (!ci || !ci.properties || !ci.properties._preview_url || !ci.properties['Custom Colors']) return;
            var mediaCell = item.querySelector('.cart-item__media');
            if (!mediaCell) return;
            mediaCell.textContent = '';
            var img = document.createElement('img');
            img.src = ci.properties._preview_url;
            img.alt = ci.properties['Custom Colors'];
            img.className = 'cart-item__image';
            img.width = 150; img.height = 150;
            img.loading = 'lazy';
            img.style.objectFit = 'cover';
            img.style.borderRadius = '4px';
            mediaCell.appendChild(img);
          });
        });
      }, 100);
    }

    // ---- localStorage persistence -------------------------------------------
    function storageKey() { return 'qfp-recolor:v1:' + S.ctx.product.id; }

    function saveState() {
      try {
        if (Object.keys(S.mapping).length) {
          localStorage.setItem(storageKey(), serializeState(S.ctx.palette.palette_hash, S.mapping));
        } else {
          localStorage.removeItem(storageKey());
        }
      } catch (e) { /* private mode / quota: state just won't persist */ }
    }

    function clearSavedState() {
      try { localStorage.removeItem(storageKey()); } catch (e) { /* no-op */ }
    }

    function restoreSavedState() {
      var st = null;
      try { st = parseState(localStorage.getItem(storageKey())); } catch (e) { st = null; }
      if (!st || st.paletteHash !== S.ctx.palette.palette_hash) return;
      var clean = {};
      Object.keys(st.mapping).forEach(function (fid) {
        if (CANONICAL_FID.test(fid) && +fid < S.ctx.palette.K && S.swatchById[st.mapping[fid]]) {
          clean[fid] = st.mapping[fid];
        }
      });
      S.mapping = clean;
    }

    // ---- edit-colors rehydrate hook ------------------------------------------
    // ?qfp_recolor_edit=<line> (1-based /cart.js line index): rehydrate the
    // mapping from the line's _recolor_mapping property, open the modal, and
    // on add REPLACE the line (/cart/change.js quantity 0, then re-add).
    function maybeEditRehydrate() {
      var m = /[?&]qfp_recolor_edit=(\d+)/.exec(window.location.search);
      if (!m) return;
      var line = parseInt(m[1], 10);
      if (!(line >= 1)) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var item = cart.items && cart.items[line - 1];
        if (!item || !item.properties || !item.properties._recolor_mapping) return;
        var mapping;
        try { mapping = JSON.parse(item.properties._recolor_mapping); } catch (e) { return; }
        if (!mapping || typeof mapping !== 'object') return;
        var clean = {};
        Object.keys(mapping).forEach(function (fid) {
          if (CANONICAL_FID.test(fid) && +fid < S.ctx.palette.K && S.swatchById[mapping[fid]]) {
            clean[fid] = mapping[fid];
          }
        });
        if (!Object.keys(clean).length) return;
        S.pendingEditMapping = clean;
        // Editing an existing line keeps its size: if the line's variant is in
        // the plan, the open flow jumps straight to colors with it chosen.
        S.pendingEditVariantId = item.variant_id !== undefined ? item.variant_id : item.id;
        S.editLine = line;
        openModal();
      }).catch(function () { /* cart unavailable: the edit link degrades to a normal page view */ });
    }

    return { init: init };
  })();

  return {
    pickAssetSize: pickAssetSize,
    priceLine: priceLine,
    priceFooter: priceFooter,
    upchargeTotal: upchargeTotal,
    upchargePct: upchargePct,
    summary: summary,
    deltaEWarnings: deltaEWarnings,
    DELTA_E_WARN_THRESHOLD: DELTA_E_WARN_THRESHOLD,
    buildApprovePayloadMeta: buildApprovePayloadMeta,
    buildCartProperties: buildCartProperties,
    serializeState: serializeState,
    parseState: parseState,
    layoutHoneycomb: layoutHoneycomb,
    sortCellsReadingOrder: sortCellsReadingOrder,
    COLORWAYS: COLORWAYS,
    nearestSwatch: nearestSwatch,
    buildColorwayMapping: buildColorwayMapping,
    COLORWAY_CHROMA_MIN: COLORWAY_CHROMA_MIN,
    tablistKeyTarget: tablistKeyTarget,
    eyedropperFamily: eyedropperFamily,
    familyMaskChunk: familyMaskChunk,
    eyedropperInputAllowed: eyedropperInputAllowed,
    clampPixel: clampPixel,
    eyedropSelectionView: eyedropSelectionView,
    eyedropReleaseSamples: eyedropReleaseSamples,
    createEyedropHighlight: createEyedropHighlight,
    eyedropHoverShowsLoupe: eyedropHoverShowsLoupe,
    EYEDROP_INSTRUCTIONS: EYEDROP_INSTRUCTIONS,
    familyColorName: familyColorName,
    eyedropChangesView: eyedropChangesView,
    EYEDROP_HILITE_MS: EYEDROP_HILITE_MS,
    LOUPE_ZOOM: LOUPE_ZOOM,
    loupeCenter: loupeCenter,
    loupeTransform: loupeTransform,
    planSizeStep: planSizeStep,
    serializeMappingCanonical: serializeMappingCanonical,
    approveResultStillValid: approveResultStillValid,
    matchEditVariant: matchEditVariant,
    HONEYCOMB_NEUTRAL_CHROMA: HONEYCOMB_NEUTRAL_CHROMA,
    _dom: _dom,
  };
});
